(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["boun-category-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var STORAGE_KEY = 'boun-combo';

    function getCombo() {
      try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); }
      catch (e) { return []; }
    }
    function setCombo(arr) {
      try { localStorage.setItem(STORAGE_KEY, JSON.stringify(arr)); } catch (e) {}
      document.dispatchEvent(new CustomEvent('boun:combo:updated', { detail: { items: arr } }));
    }

    function syncComboButtons() {
      var combo = getCombo();
      document.querySelectorAll('[data-combo-add]').forEach(function (btn) {
        var id = btn.getAttribute('data-combo-add');
        var label = btn.querySelector('.boun-cats__btn-label');
        if (combo.indexOf(id) !== -1) {
          btn.classList.add('is-added');
          if (label) label.textContent = '✓ En el combo';
        } else {
          btn.classList.remove('is-added');
          if (label) label.textContent = 'Añadir al combo';
        }
      });
    }

    document.addEventListener('click', function (e) {
      var comboBtn = e.target.closest('[data-combo-add]');
      if (!comboBtn) return;
      e.preventDefault();
      var id = comboBtn.getAttribute('data-combo-add');
      var line = comboBtn.getAttribute('data-line');
      comboBtn.classList.add('is-added');
      var lbl = comboBtn.querySelector('.boun-cats__btn-label');
      if (lbl) lbl.textContent = '✓ Yendo al combo…';
      try {
        var stage = JSON.parse(localStorage.getItem('boun-combo-stage') || '[]');
        if (stage.indexOf(id) === -1) stage.push(id);
        localStorage.setItem('boun-combo-stage', JSON.stringify(stage));
      } catch (err) {}
      window.location.href = '/pages/arma-tu-combo?from=' + encodeURIComponent(line || 'grid');
    });

    /* v270 — ML-style quantity dropdown on cards (delegated). Writes the chosen
       value into the hidden [data-qty-value] input so add-to-cart picks it up. */
    function bounCatsCloseQty(except) {
      document.querySelectorAll('.boun-cats__qtybox.is-open').forEach(function (box) {
        if (box === except) return;
        box.classList.remove('is-open');
        var m = box.querySelector('[data-qty-menu]'); if (m) m.hidden = true;
        var t = box.querySelector('[data-qty-toggle]'); if (t) t.setAttribute('aria-expanded', 'false');
      });
    }
    document.addEventListener('click', function (e) {
      var toggle = e.target.closest('[data-qty-toggle]');
      var opt = e.target.closest('[data-qty-opt]');
      if (!toggle && !opt) { bounCatsCloseQty(null); return; }
      if (toggle) {
        var box = toggle.closest('[data-qtybox]');
        if (!box) return;
        var willOpen = !box.classList.contains('is-open');
        bounCatsCloseQty(box);
        var menu = box.querySelector('[data-qty-menu]');
        box.classList.toggle('is-open', willOpen);
        if (menu) menu.hidden = !willOpen;
        toggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        return;
      }
      if (opt) {
        var box2 = opt.closest('[data-qtybox]');
        var form = opt.closest('[data-cart-form]');
        var v = parseInt(opt.getAttribute('data-qty-opt'), 10) || 1;
        if (form) { var hidden = form.querySelector('[data-qty-value]'); if (hidden) hidden.value = v; }
        if (box2) {
          var disp = box2.querySelector('[data-qty-display]'); if (disp) disp.textContent = v;
          box2.querySelectorAll('[data-qty-opt]').forEach(function (o) {
            var sel = o === opt;
            o.classList.toggle('is-selected', sel);
            o.setAttribute('aria-selected', sel ? 'true' : 'false');
          });
          bounCatsCloseQty(null);
        }
      }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') bounCatsCloseQty(null); });

    document.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-cart-form]');
      if (!form) return;
      e.preventDefault();
      var btn = form.querySelector('.boun-cats__btn--cart');
      var label = btn ? btn.querySelector('.boun-cats__btn-label') : null;
      var originalText = label ? label.textContent : 'Añadir al carrito';
      if (btn) {
        btn.classList.remove('is-added', 'is-error');
        btn.classList.add('is-loading');
        if (label) label.textContent = 'Añadiendo…';
      }
      var formData = new FormData(form);
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
        .then(function () {
          if (btn) {
            btn.classList.remove('is-loading');
            btn.classList.add('is-added');
            if (label) label.textContent = '✓ Añadido';
          }
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          document.dispatchEvent(new CustomEvent('boun:cart:added', { detail: { line: form.dataset.line } }));
          /* v95.1 — Open cart drawer in place (matches product page + combo flow) */
          if (typeof window.openBounCartDrawer === 'function') {
            window.openBounCartDrawer();
          }
          setTimeout(function () {
            if (btn) btn.classList.remove('is-added');
            if (label) label.textContent = originalText;
          }, 2200);
        })
        .catch(function () {
          if (btn) {
            btn.classList.remove('is-loading');
            btn.classList.add('is-error');
            if (label) label.textContent = 'Error · Reintentar';
          }
          setTimeout(function () {
            if (btn) btn.classList.remove('is-error');
            if (label) label.textContent = originalText;
          }, 2400);
        });
    });

    function initCarousel(root) {
      if (!root || root.__bounCatsCarouselInit) return;
      root.__bounCatsCarouselInit = true;

      var scroller = root.querySelector('[data-cats-scroller]');
      var dots     = root.querySelectorAll('[data-cats-dot]');
      var cells    = scroller ? scroller.querySelectorAll('.boun-cats__cell') : [];
      var prevBtn  = root.querySelector('[data-cats-prev]');
      var nextBtn  = root.querySelector('[data-cats-next]');
      var section  = root.querySelector('.boun-cats') || root;
      if (!scroller || !cells.length) return;

      function checkOverflow() {
        var hasOverflow = scroller.scrollWidth > scroller.clientWidth + 8;
        if (hasOverflow) section.classList.add('boun-cats--has-overflow');
        else section.classList.remove('boun-cats--has-overflow');
      }
      checkOverflow();
      window.addEventListener('resize', checkOverflow);

      function setActive(idx) {
        dots.forEach(function (d, i) {
          if (i === idx) { d.classList.add('is-active'); d.setAttribute('aria-selected', 'true'); }
          else { d.classList.remove('is-active'); d.setAttribute('aria-selected', 'false'); }
        });
      }

      function updateArrows() {
        if (!prevBtn || !nextBtn) return;
        var maxScroll = scroller.scrollWidth - scroller.clientWidth;
        var scrollLeft = scroller.scrollLeft;
        // small tolerance for sub-pixel
        if (scrollLeft <= 4) prevBtn.setAttribute('hidden', '');
        else prevBtn.removeAttribute('hidden');
        if (scrollLeft >= maxScroll - 4) nextBtn.setAttribute('hidden', '');
        else nextBtn.removeAttribute('hidden');
      }
      updateArrows();
      scroller.addEventListener('scroll', updateArrows, { passive: true });
      window.addEventListener('resize', updateArrows);

      var io = new IntersectionObserver(function (entries) {
        var best = null;
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            if (!best || entry.intersectionRatio > best.intersectionRatio) best = entry;
          }
        });
        if (best) {
          var idx = Array.prototype.indexOf.call(cells, best.target);
          if (idx > -1) setActive(idx);
        }
      }, { root: scroller, threshold: [0.55, 0.75, 0.95] });
      cells.forEach(function (cell) { io.observe(cell); });

      // Click on dot → scroll to corresponding card
      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () {
          var target = cells[i];
          if (!target) return;
          var scrollerRect = scroller.getBoundingClientRect();
          var targetRect = target.getBoundingClientRect();
          var offset = (targetRect.left - scrollerRect.left) + (targetRect.width / 2) - (scrollerRect.width / 2);
          scroller.scrollBy({ left: offset, behavior: 'smooth' });
        });
      });

      // Arrow nav: scroll by 1 card width + gap
      function getStep() {
        if (!cells[0]) return 0;
        var rect = cells[0].getBoundingClientRect();
        return rect.width + 14; // approximate gap
      }
      if (nextBtn) nextBtn.addEventListener('click', function () {
        scroller.scrollBy({ left: getStep(), behavior: 'smooth' });
      });
      if (prevBtn) prevBtn.addEventListener('click', function () {
        scroller.scrollBy({ left: -getStep(), behavior: 'smooth' });
      });

      // Keyboard
      scroller.setAttribute('tabindex', '0');
      scroller.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
        e.preventDefault();
        var currentIdx = 0;
        dots.forEach(function (d, i) { if (d.classList.contains('is-active')) currentIdx = i; });
        var nextIdx = e.key === 'ArrowRight'
          ? Math.min(currentIdx + 1, cells.length - 1)
          : Math.max(currentIdx - 1, 0);
        var target = cells[nextIdx];
        if (target && target.scrollIntoView) {
          target.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        }
      });
    }

    function initCarouselAll() {
      document.querySelectorAll('[data-boun-cats]').forEach(initCarousel);
    }

    /* ----- v30 Filter pills ------------------------------------------------
       Toggle visibility of cells based on the active pill's data-cats-use.
       When the active pill is "all", everything is visible. Otherwise the
       cell stays visible only if its data-cats-uses includes that token.
       Dots that map to hidden cells are also hidden so pagination stays
       consistent with what's actually scrollable. */
    function initFilters(root) {
      if (!root || root.__bounCatsFiltersInit) return;
      root.__bounCatsFiltersInit = true;
      var pills = root.querySelectorAll('[data-cats-use]');
      var cells = root.querySelectorAll('.boun-cats__cell');
      var dots  = root.querySelectorAll('[data-cats-dot]');
      var prevBtn = root.querySelector('[data-cats-prev]');
      var nextBtn = root.querySelector('[data-cats-next]');
      var scroller = root.querySelector('[data-cats-scroller]');
      if (!pills.length || !cells.length) return;

      function apply(use) {
        cells.forEach(function (cell, i) {
          var uses = (cell.getAttribute('data-cats-uses') || '').split(',').map(function (s) { return s.trim(); });
          var show = use === 'all' || uses.indexOf(use) !== -1;
          cell.classList.toggle('is-hidden', !show);
          var dot = dots[i];
          if (dot) dot.classList.toggle('is-hidden', !show);
        });
        /* Scroll back to the start so the first visible card is in view */
        if (scroller) scroller.scrollTo({ left: 0, behavior: 'smooth' });
        /* Reset arrow visibility */
        if (prevBtn) prevBtn.setAttribute('hidden', '');
        if (nextBtn) {
          /* Recompute on next frame after layout */
          requestAnimationFrame(function () {
            var maxScroll = scroller ? scroller.scrollWidth - scroller.clientWidth : 0;
            if (maxScroll > 4 && nextBtn) nextBtn.removeAttribute('hidden');
            else if (nextBtn) nextBtn.setAttribute('hidden', '');
          });
        }
      }

      /* v62 — Mobile collapsible filter wrapper. Toggle button shows
         the active pill label; tapping it expands the pill list; tapping
         any pill applies the filter and auto-collapses. */
      var filterWrap = root.querySelector('[data-cats-filter-wrap]');
      var toggleBtn = root.querySelector('[data-cats-toggle]');
      var toggleLabel = root.querySelector('[data-cats-toggle-label]');
      function setActivePillLabel(pill) {
        if (!toggleLabel || !pill) return;
        var span = pill.querySelector('span');
        if (span) toggleLabel.textContent = 'Filtrar: ' + span.textContent;
      }
      if (toggleBtn && filterWrap) {
        toggleBtn.addEventListener('click', function () {
          var isOpen = filterWrap.classList.toggle('is-open');
          toggleBtn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        });
      }

      pills.forEach(function (pill) {
        pill.addEventListener('click', function () {
          var use = pill.getAttribute('data-cats-use');
          /* v65 — toggle-off: clicking an already-active pill clears the
             filter back to "all" so users don't need a visible Todos pill. */
          var alreadyActive = pill.classList.contains('is-active');
          if (alreadyActive && use !== 'all') { use = 'all'; }
          pills.forEach(function (p) {
            var on = use === 'all' ? p.getAttribute('data-cats-use') === 'all' : p === pill;
            p.classList.toggle('is-active', on);
            p.setAttribute('aria-selected', on ? 'true' : 'false');
          });
          apply(use);
          /* Auto-collapse on mobile + update toggle label */
          if (filterWrap) filterWrap.classList.remove('is-open');
          if (toggleBtn) toggleBtn.setAttribute('aria-expanded', 'false');
          setActivePillLabel(pill);
        });
      });

      /* Initialize toggle label from currently active pill */
      var activePill = root.querySelector('[data-cats-use].is-active') || pills[0];
      setActivePillLabel(activePill);
    }
    function initFiltersAll() {
      document.querySelectorAll('[data-boun-cats]').forEach(initFilters);
    }

    function init() { syncComboButtons(); initCarouselAll(); initFiltersAll(); }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["boun-hero-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.__bounHeroInit) return;
      root.__bounHeroInit = true;

      var slides = root.querySelectorAll('[data-hero-slide]');
      var nums   = root.querySelectorAll('[data-hero-num]');
      var dotBtns = root.querySelectorAll('[data-hero-dot]');
      var prevBtn = root.querySelector('[data-hero-prev]');
      var nextBtn = root.querySelector('[data-hero-next]');
      var ppBtn   = root.querySelector('[data-hero-playpause]');
      var autoplayMs = parseInt(root.getAttribute('data-autoplay'), 10) || 6000;
      var idx = 0;
      var len = slides.length;
      var timer = null;
      var manuallyPaused = false;
      var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function go(next) {
        idx = ((next % len) + len) % len;
        root.style.setProperty('--idx', idx);
        slides.forEach(function (s, i) { s.classList.toggle('is-active', i === idx); });
        nums.forEach(function (n, i) { n.classList.toggle('is-active', i === idx); });
        dotBtns.forEach(function (b, i) {
          b.setAttribute('aria-selected', i === idx ? 'true' : 'false');
        });
        restartTimer();
      }

      function next() { go(idx + 1); }
      function prev() { go(idx - 1); }

      function restartTimer() {
        if (prefersReduced || manuallyPaused) return;
        if (timer) clearTimeout(timer);
        timer = setTimeout(next, autoplayMs);
      }
      function softPause() {
        if (timer) { clearTimeout(timer); timer = null; }
      }
      function softResume() {
        if (manuallyPaused) return;
        restartTimer();
      }
      function togglePlayPause() {
        manuallyPaused = !manuallyPaused;
        if (manuallyPaused) {
          softPause();
          root.classList.add('is-paused');
          if (ppBtn) ppBtn.setAttribute('aria-label', 'Reanudar reproducción automática');
        } else {
          root.classList.remove('is-paused');
          restartTimer();
          if (ppBtn) ppBtn.setAttribute('aria-label', 'Pausar reproducción automática');
        }
      }

      if (nextBtn) nextBtn.addEventListener('click', function () { next(); });
      if (prevBtn) prevBtn.addEventListener('click', function () { prev(); });
      if (ppBtn) ppBtn.addEventListener('click', togglePlayPause);

      dotBtns.forEach(function (b, i) {
        b.addEventListener('click', function () {
          go(i);
        });
      });

      root.addEventListener('mouseenter', softPause);
      root.addEventListener('mouseleave', softResume);

      document.addEventListener('visibilitychange', function () {
        if (document.hidden) softPause();
        else softResume();
      });
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) softResume();
            else softPause();
          });
        }, { threshold: 0.25 });
        io.observe(root);
      }

      root.setAttribute('tabindex', '0');
      root.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { e.preventDefault(); prev(); }
        else if (e.key === 'ArrowRight') { e.preventDefault(); next(); }
        else if (e.key === ' ' || e.key === 'Spacebar') { e.preventDefault(); togglePlayPause(); }
      });

      var touchStartX = 0, touchStartY = 0, touchActive = false;
      root.addEventListener('touchstart', function (e) {
        if (!e.touches[0]) return;
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
        touchActive = true;
        softPause();
      }, { passive: true });
      root.addEventListener('touchend', function (e) {
        if (!touchActive) return;
        touchActive = false;
        var t = e.changedTouches[0];
        if (!t) { softResume(); return; }
        var dx = t.clientX - touchStartX;
        var dy = t.clientY - touchStartY;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) {
          if (dx < 0) next(); else prev();
        } else {
          softResume();
        }
      }, { passive: true });

      root.style.setProperty('--idx', 0);
      restartTimer();
    }

    function initAll() {
      document.querySelectorAll('[data-hero-carousel]').forEach(init);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["boun-hero-split"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(el) {
      if (!el || el.__bounInit) return;
      el.__bounInit = true;

      var products = el.querySelector('[data-boun-hero-products]');
      var openTimer = null;
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      setTimeout(function () { el.classList.add('is-entered'); }, 300);

      if (!reduceMotion && products) {
        el.addEventListener('mousemove', function (e) {
          if (el.classList.contains('is-open')) {
            products.style.transform = 'translate(-50%, -50%)';
            return;
          }
          var rect = el.getBoundingClientRect();
          var x = (e.clientX - rect.left) / rect.width - 0.5;
          products.style.transform = 'translate(calc(-50% + ' + (x * 12) + 'px), -50%)';
        });
        el.addEventListener('mouseleave', function () {
          products.style.transform = 'translate(-50%, -50%)';
        });
      }

      var mediaDesktop = window.matchMedia('(min-width: 769px)');
      el.addEventListener('mouseenter', function () {
        if (!mediaDesktop.matches) return;
        clearTimeout(openTimer);
        openTimer = setTimeout(function () { el.classList.add('is-open'); }, 180);
      });
      el.addEventListener('mouseleave', function () {
        clearTimeout(openTimer);
        el.classList.remove('is-open');
      });
    }

    function initAll() {
      document.querySelectorAll('[data-boun-hero]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["boun-payments"] && !Shopify.designMode) return;
  try {
    
  /* v82.1 — Lock background scroll when the cart drawer is open.
     `dialog.showModal()` should do this by spec but Horizon's open
     state is sometimes managed without the [open] attr, so we track
     it via the dialog's lifecycle events and toggle a class on <html>. */
  (function () {
    /* v243 — measure the scrollbar width before locking so we can reserve
       its gutter via padding-right. Prevents a layout jump when overflow
       toggles to hidden. */
    function measureSbWidth() {
      var sb = window.innerWidth - document.documentElement.clientWidth;
      if (sb < 0) sb = 0;
      document.documentElement.style.setProperty('--boun-sb-width', sb + 'px');
    }
    function lock() {
      measureSbWidth();
      document.documentElement.classList.add('boun-drawer-locked');
    }
    function unlock() {
      document.documentElement.classList.remove('boun-drawer-locked');
    }
    function bindDialog() {
      var dialog = document.querySelector('cart-drawer-component dialog');
      if (!dialog || dialog.__bounLockBound) return;
      dialog.__bounLockBound = true;
      /* Initial state */
      if (dialog.open) lock();
      /* Horizon dialog-component dispatches custom events */
      dialog.addEventListener('open', lock);
      dialog.addEventListener('close', unlock);
      dialog.addEventListener('cancel', unlock);
      /* Watch for [open] attribute mutations as backup */
      var attrObserver = new MutationObserver(function (mutations) {
        mutations.forEach(function (m) {
          if (m.attributeName === 'open') {
            if (dialog.hasAttribute('open')) lock();
            else unlock();
          }
        });
      });
      attrObserver.observe(dialog, { attributes: true, attributeFilter: ['open'] });
    }
    /* Also listen for the cart trigger click as the source of truth */
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-testid="cart-drawer-trigger"]')) {
        setTimeout(lock, 50);
        bindDialog();
      }
      /* Close on backdrop click or close button */
      if (e.target.closest('.cart-drawer__close-button, dialog.cart-drawer__dialog')) {
        var dialog = document.querySelector('cart-drawer-component dialog');
        /* If click was on backdrop (the dialog itself, not its panel) */
        if (e.target === dialog) {
          setTimeout(unlock, 50);
        }
        /* If click was on close button */
        if (e.target.closest('.cart-drawer__close-button')) {
          setTimeout(unlock, 50);
        }
      }
    });
    /* Listen for Escape key (closes dialog) */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') setTimeout(unlock, 50);
    });
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bindDialog);
    } else {
      bindDialog();
    }
  })();

  /* v81.6 — Inject style tag at document head so my CSS loads AFTER
     all Horizon stylesheets. This guarantees cascade priority for the
     cart drawer image sizing rules without relying on inline-style JS. */
  (function () {
    if (document.getElementById('boun-drawer-img-fix-style')) return;
    var s = document.createElement('style');
    s.id = 'boun-drawer-img-fix-style';
    s.textContent = [
      'cart-drawer-component .cart-items__media-container,',
      'cart-drawer-component a.cart-items__media-container {',
      '  position: relative !important;',
      '  display: block !important;',
      '}',
      'cart-drawer-component .cart-items__media-container .cart-items__media-image,',
      'cart-drawer-component .cart-items__media-container img,',
      'cart-drawer-component dialog .cart-items__media-image {',
      '  position: absolute !important;',
      '  inset: 6px !important;',
      '  width: calc(100% - 12px) !important;',
      '  height: calc(100% - 12px) !important;',
      '  max-width: none !important;',
      '  max-height: none !important;',
      '  min-width: 0 !important;',
      '  min-height: 0 !important;',
      '  object-fit: contain !important;',
      '  object-position: center !important;',
      '  mix-blend-mode: multiply !important;',
      '  padding: 0 !important;',
      '  margin: 0 !important;',
      '  background: transparent !important;',
      '}'
    ].join('\n');
    (document.head || document.documentElement).appendChild(s);
  })();

  /* v81.5 — Force cart drawer images to fill their 72px container.
     Horizon's CSS clamps .cart-items__media-image to 24x24 with cascade
     priority equal to ours, so external CSS can't override. Use inline
     `style` attribute (inline beats all stylesheet rules of any
     specificity). Polled because the drawer renders images lazily on
     first open and re-renders on qty/remove. */
  (function () {
    function fixDrawerImages() {
      var imgs = document.querySelectorAll('cart-drawer-component .cart-items__media-image');
      imgs.forEach(function (img) {
        /* Always re-apply (no bail-out flag). Horizon View Transitions
           sometimes clone the element and strip inline styles, so the
           idempotent re-apply is the safety net. */
        if (img.style.getPropertyValue('width') === 'calc(100% - 12px)' && img.offsetWidth > 30) {
          // Already sized correctly — skip to avoid layout thrash
          return;
        }
        img.style.setProperty('position', 'absolute', 'important');
        img.style.setProperty('inset', '6px', 'important');
        img.style.setProperty('width', 'calc(100% - 12px)', 'important');
        img.style.setProperty('height', 'calc(100% - 12px)', 'important');
        img.style.setProperty('max-width', 'none', 'important');
        img.style.setProperty('max-height', 'none', 'important');
        img.style.setProperty('min-width', '0', 'important');
        img.style.setProperty('min-height', '0', 'important');
        img.style.setProperty('object-fit', 'contain', 'important');
        img.style.setProperty('mix-blend-mode', 'multiply', 'important');
        img.style.setProperty('padding', '0', 'important');
        img.style.setProperty('background', 'transparent', 'important');
        var c = img.closest('.cart-items__media-container');
        if (c) c.style.setProperty('position', 'relative', 'important');
      });

      /* v82.4 — Hide only the KNOWN extra metadata nodes (bundle child
         list, properties, unit-price, discounts). KEEP variants visible. */
      var hideSelectors = [
        '.cart-items__properties',
        '.cart-items__property',
        '.cart-items__bundle',
        '.cart-items__bundle-products',
        '.cart-items__unit-price',
        '.cart-items__unit-price-wrapper',
        '.cart-items__selling-plan',
        '.cart-items__discounts',
        '.cart-items__discount',
        '.cart-discount',
        '.price--unit',
        '.price__unit',
        '.unit-price'
      ];
      var hideEls = document.querySelectorAll(
        hideSelectors.map(function (s) { return 'cart-drawer-component .cart-items__details ' + s; }).join(',')
      );
      hideEls.forEach(function (el) {
        if (el.querySelector('a.cart-items__title')) return; // never hide a wrapper that contains the title
        el.style.setProperty('display', 'none', 'important');
      });
    }
    // Run on load + repeatedly for safety net (drawer is async-rendered)
    fixDrawerImages();
    var pollInterval = setInterval(fixDrawerImages, 500);
    // After 30s of polling, stop — by then everything should be wired up
    setTimeout(function () { clearInterval(pollInterval); }, 30000);
    // Also re-run on common cart events + after section reloads
    document.addEventListener('cart:refresh', fixDrawerImages);
    document.addEventListener('cart-update', fixDrawerImages);
    document.addEventListener('shopify:section:load', fixDrawerImages);
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-testid="cart-drawer-trigger"]')) {
        // Run a few times to catch the lazy render
        setTimeout(fixDrawerImages, 50);
        setTimeout(fixDrawerImages, 200);
        setTimeout(fixDrawerImages, 500);
      }
    });
    // MutationObserver as final safety net
    if (typeof MutationObserver !== 'undefined') {
      var observer = new MutationObserver(fixDrawerImages);
      function bindObserver() {
        var drawer = document.querySelector('cart-drawer-component');
        if (drawer) observer.observe(drawer, { childList: true, subtree: true, attributes: true });
      }
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', bindObserver);
      } else {
        bindObserver();
      }
    }
  })();

  /* v71 — Sticky header scroll effect.
     Adds .is-scrolled to the header section group when window.scrollY > 20
     so CSS can fade in the translucent backdrop + shadow. Lives in
     boun-payments because that section ships on every page. */
  (function () {
    function initStickyHeader() {
      var headerGroup = document.querySelector('.shopify-section-group-header-group');
      if (!headerGroup || headerGroup.__bounStickyInit) return;
      headerGroup.__bounStickyInit = true;
      var threshold = 20;
      var ticking = false;
      function update() {
        var scrolled = window.scrollY > threshold;
        headerGroup.classList.toggle('is-scrolled', scrolled);
        ticking = false;
      }
      window.addEventListener('scroll', function () {
        if (!ticking) { requestAnimationFrame(update); ticking = true; }
      }, { passive: true });
      update();
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initStickyHeader);
    } else {
      initStickyHeader();
    }
    document.addEventListener('shopify:section:load', initStickyHeader);
  })();

  /* v83c-rebuild-1779835544 — force Shopify bundle regeneration */
  /* v83c — Programmatic cart-drawer opener with Shopify Section Rendering API
     refresh. Critical fix: when something is added to the cart via raw
     /cart/add.js (combo / shop / product page), Horizon's cart-drawer-component
     does NOT auto-re-render — so opening it shows stale "empty cart" state.
     We fetch the containing section's fresh HTML, swap the cart-drawer-
     component's innerHTML, THEN open the drawer. */
  (function () {
    function openDrawer() {
      var i, el;
      /* v112 — Always open the inner <dialog> via showModal directly.
         After section refresh, the new dialog may arrive with `open`
         attribute (non-modal). Force close + showModal to ensure true
         modal state with backdrop. */
      var dialog = document.querySelector('cart-drawer-component dialog, dialog.cart-drawer__dialog, dialog#cart-drawer');
      if (dialog) {
        var isModal = false;
        try { isModal = dialog.matches(':modal'); } catch (e) {}
        if (!isModal) {
          if (dialog.hasAttribute('open')) {
            try { dialog.close(); } catch (e) {}
          }
          try { dialog.showModal(); return true; } catch (e) {}
          try { dialog.show(); return true; } catch (e) {}
          dialog.setAttribute('open', '');
        }
        return true;
      }
      /* Custom element fallbacks (rare) */
      var cmp = document.querySelector('cart-drawer-component');
      if (cmp) {
        if (typeof cmp.show === 'function')      { try { cmp.show();      return true; } catch (e) {} }
        if (typeof cmp.open === 'function')      { try { cmp.open();      return true; } catch (e) {} }
        if (typeof cmp.showModal === 'function') { try { cmp.showModal(); return true; } catch (e) {} }
      }
      /* 3) Click any header cart trigger */
      var triggerSelectors = [
        '[data-testid="cart-drawer-trigger"]',
        '[data-cart-drawer-trigger]',
        'button[command="show-modal"][commandfor*="cart" i]',
        'button[aria-controls*="cart" i]',
        '.header__cart',
        'header [href$="/cart"]',
        'a[href="/cart"]',
        'a[href$="/cart"]',
        'header-cart-link a',
        'header-cart-link button',
        'header .header-actions__action[aria-label*="Carrito" i]',
        'button[aria-label*="Carrito" i]',
        'button[aria-label*="cart" i]',
        'summary[aria-label*="cart" i]'
      ];
      for (i = 0; i < triggerSelectors.length; i++) {
        el = document.querySelector(triggerSelectors[i]);
        if (el && typeof el.click === 'function') {
          el.click();
          return true;
        }
      }
      return false;
    }

    /* Refresh cart-drawer-component's containing section via Shopify Section
       Rendering API so newly added items show up. */
    function refreshCartSection() {
      return new Promise(function (resolve) {
        try {
          var cmp = document.querySelector('cart-drawer-component');
          if (!cmp) return resolve(false);
          var section = cmp.closest('[id^="shopify-section-"]');
          if (!section) return resolve(false);
          var sid = section.id.replace('shopify-section-', '');
          fetch('/?sections=' + encodeURIComponent(sid), {
            headers: { 'Accept': 'application/json' },
            credentials: 'same-origin'
          }).then(function (r) { return r.ok ? r.json() : null; }).then(function (data) {
            if (!data || !data[sid]) return resolve(false);
            var temp = document.createElement('div');
            temp.innerHTML = data[sid];
            var newCart = temp.querySelector('cart-drawer-component');
            var curCart = document.querySelector('cart-drawer-component');
            if (newCart && curCart) {
              curCart.innerHTML = newCart.innerHTML;
              /* Re-trigger combo grouping + image fix on the fresh markup */
              document.dispatchEvent(new CustomEvent('cart:refresh'));
              return resolve(true);
            }
            resolve(false);
          }).catch(function () { resolve(false); });
        } catch (e) { resolve(false); }
      });
    }

    /* Public helper — refresh + open. Called by combo + shop + PDP after
       /cart/add.js completes. */
    window.openBounCartDrawer = function () {
      refreshCartSection().then(function () {
        setTimeout(function () {
          if (openDrawer()) return;
          var attempts = 0;
          var iv = setInterval(function () {
            attempts++;
            if (openDrawer() || attempts > 25) clearInterval(iv);
          }, 120);
        }, 60);
      });
      return true;
    };

    /* Also expose a pure refresh helper (no open) */
    window.refreshBounCart = refreshCartSection;

    /* Auto-open if URL contains ?open_drawer=1 (e.g. after a /discount/CODE
       redirect from the combo flow). Strips the param after firing. */
    function maybeOpenDrawer() {
      try {
        var params = new URLSearchParams(window.location.search);
        if (params.get('open_drawer') !== '1') return;
        window.openBounCartDrawer();
        params.delete('open_drawer');
        var clean = window.location.pathname + (params.toString() ? '?' + params.toString() : '') + window.location.hash;
        window.history.replaceState({}, '', clean);
      } catch (e) {}
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', maybeOpenDrawer);
    } else {
      maybeOpenDrawer();
    }
  })();

  /* v83 — If the user lands on /cart (legacy standalone page), redirect to
     home + open the drawer. This sunsets the standalone cart page entirely. */
  (function () {
    if (window.location.pathname === '/cart' || window.location.pathname === '/cart/') {
      var qs = window.location.search ? window.location.search + '&open_drawer=1' : '?open_drawer=1';
      window.location.replace('/' + qs);
    }
  })();

  /* v109 — Loop-style cart drawer enhancements:
       1. Change title to "Tu carrito" (instead of Horizon default).
       2. Inject free-shipping progress banner pinned just below the
          title. Reads cart total, computes progress to $90.000 COP
          threshold, fills the bar accordingly.
       3. Listens to cart events to re-render banner + title count.
  */
  (function () {
    var FREE_SHIPPING_THRESHOLD = 9000000; // $90.000 in cents
    var TITLE_TEXT = 'Tu carrito';

    function fmt(cents) {
      var n = Math.round(cents / 100);
      try {
        return new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP', maximumFractionDigits: 0 }).format(n);
      } catch (e) {
        return '$' + n.toLocaleString('es-CO');
      }
    }

    /* v118 — expose banner injection globally + add MutationObserver
       so the banner re-inserts INSTANTLY whenever the cart-drawer-
       component innerHTML is replaced (combo add, qty change, etc).
       Eliminates the ~2 second gap where the banner appears "gone". */
    function ensureBanner(cart) {
      var drawer = document.querySelector('cart-drawer-component');
      if (!drawer) return;
      var content = drawer.querySelector('.cart-drawer__content');
      if (!content) return;
      /* v125 — if cart is empty (no items OR drawer shows empty state),
         remove any banner and clear cache. Don't render anything. */
      var cartEmpty = !cart || !cart.item_count || cart.item_count <= 0;
      if (cartEmpty || isCartDrawerEmpty(drawer)) {
        var existing = drawer.querySelector('.boun-shipping-banner');
        if (existing && existing.parentNode) existing.parentNode.removeChild(existing);
        window.__bounLastBanner = null;
        return;
      }
      var banner = drawer.querySelector('.boun-shipping-banner');
      if (!banner) {
        banner = document.createElement('div');
        banner.className = 'boun-shipping-banner';
        banner.innerHTML = ''
          + '<div class="boun-shipping-banner__msg" data-banner-msg></div>'
          + '<div class="boun-shipping-banner__track"><div class="boun-shipping-banner__fill" data-banner-fill></div></div>';
        content.insertBefore(banner, content.firstChild);
      }
      var msgEl = banner.querySelector('[data-banner-msg]');
      var fillEl = banner.querySelector('[data-banner-fill]');
      var total = (cart && cart.total_price) || 0;
      var pct = Math.min(100, Math.round((total / FREE_SHIPPING_THRESHOLD) * 100));
      var remaining = Math.max(0, FREE_SHIPPING_THRESHOLD - total);
      if (msgEl) {
        if (total >= FREE_SHIPPING_THRESHOLD) {
          msgEl.innerHTML = '¡Has desbloqueado envío gratis!';
        } else {
          msgEl.innerHTML = 'Te faltan <strong>' + fmt(remaining) + '</strong> para envío gratis.';
        }
      }
      if (fillEl) fillEl.style.width = pct + '%';
      banner.style.display = '';
      /* Cache last banner state for synchronous re-insertion */
      window.__bounLastBanner = { html: banner.outerHTML, total: total };
    }

    /* v118 — Instant re-insertion when innerHTML was replaced.
       Uses cached banner HTML, no async fetch needed. Called from
       MutationObserver when the drawer is repainted.
       v125 — Skip / remove banner when cart is empty; refresh state. */
    function isCartDrawerEmpty(drawer) {
      if (!drawer) return true;
      var rows = drawer.querySelectorAll(
        '.cart-items__table-row, cart-items-component .cart-items > *, [data-cart-item], .cart-item'
      );
      return rows.length === 0;
    }
    function reinsertCachedBanner() {
      var drawer = document.querySelector('cart-drawer-component');
      if (!drawer) return;
      var content = drawer.querySelector('.cart-drawer__content');
      if (!content) return;
      /* v125 — if the drawer shows the empty state, remove any
         stale banner and don't reinsert. Also clear the cache so
         that the next non-empty add starts fresh. */
      if (isCartDrawerEmpty(drawer)) {
        var existing = drawer.querySelector('.boun-shipping-banner');
        if (existing && existing.parentNode) existing.parentNode.removeChild(existing);
        window.__bounLastBanner = null;
        return;
      }
      /* Skip if banner already present */
      if (drawer.querySelector('.boun-shipping-banner')) return;
      var cached = window.__bounLastBanner;
      if (!cached || !cached.html) return;
      var temp = document.createElement('div');
      temp.innerHTML = cached.html;
      var bannerEl = temp.firstElementChild;
      if (bannerEl) content.insertBefore(bannerEl, content.firstChild);
      /* Also refresh from /cart.js (non-blocking) so the banner reflects
         the latest total — the cached HTML might be one cycle stale. */
      try {
        fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            window.__bounLastCart = cart;
            ensureBanner(cart);
          })
          .catch(function () {});
      } catch (e) {}
    }

    /* v118 — MutationObserver watches cart-drawer-component for any
       child changes. When fired, re-insert cached banner synchronously
       (no async). Skip mutations caused by our own banner/bundle
       insertions to avoid feedback loop. */
    /* v157 — Inject the product color name as a subtitle under each
       cart line item title (Loop pattern: "Black" / "Negro" gray text).
       Lookup by variant_id from data-key. Falls back to "Negro" if no
       metafield colorName is set on the product. */
    function applyColorSubtitle(drawer) {
      if (!drawer) drawer = document.querySelector('cart-drawer-component');
      if (!drawer) return;
      var catalog = window.__bounCatalog || [];
      if (catalog.length === 0) return;
      var catalogByVariant = {};
      catalog.forEach(function (p) {
        if (p && p.variantId) catalogByVariant[String(p.variantId)] = p;
      });
      var rows = drawer.querySelectorAll('.cart-items__table-row');
      rows.forEach(function (row) {
        var dataKey = row.getAttribute('data-key') || row.dataset.key || '';
        var variantId = (dataKey.split(':')[0] || '').trim();
        if (!variantId) return;
        var product = catalogByVariant[variantId];
        if (!product) return;
        var colorName = product.colorName || 'Negro';
        var details = row.querySelector('.cart-items__details');
        if (!details) return;
        var sub = details.querySelector('.boun-cart-color-sub');
        if (!sub) {
          sub = document.createElement('div');
          sub.className = 'boun-cart-color-sub';
          /* Insert right after the .cart-items__product-info (title block) */
          var info = details.querySelector('.cart-items__product-info');
          if (info && info.nextSibling) {
            info.parentNode.insertBefore(sub, info.nextSibling);
          } else {
            details.appendChild(sub);
          }
        }
        if (sub.textContent !== colorName) sub.textContent = colorName;
      });
    }
    /* v154 — Strip trailing ",00" centavos from cart prices.
       Colombian Pesos don't typically use cents. Cleans any text node
       inside .cart-items__price, .boun-combo-bundle__price, etc. */
    function stripCentavos(drawer) {
      if (!drawer) drawer = document.querySelector('cart-drawer-component');
      if (!drawer) return;
      var priceEls = drawer.querySelectorAll(
        '.cart-items__price, .cart-items__price *, ' +
        '.boun-combo-bundle__price, .boun-combo-bundle__price *, ' +
        '.boun-combo-bundle__price-strike, .boun-combo-bundle__price-final, ' +
        '.boun-cart-totals-strike, .boun-cart-totals-final, ' +
        '.boun-cart-shipping-value'
      );
      priceEls.forEach(function (el) {
        if (el.children.length > 0) return; /* only leaf text nodes */
        var t = el.textContent;
        if (t && /,00\b/.test(t)) {
          el.textContent = t.replace(/,00\b/g, '');
        }
      });
    }
    /* v124 — Swap trash↔minus per line item based on qty.
       qty == 1: keep the trash icon visible (clicking removes the line).
       qty  > 1: swap trash for the native minus button (clicking decrements). */
    function applyQtyButtonSwap(drawer) {
      if (!drawer) drawer = document.querySelector('cart-drawer-component');
      if (!drawer) return;
      var controls = drawer.querySelectorAll('.cart-items__quantity-controls');
      controls.forEach(function (ctrl) {
        var inp = ctrl.querySelector('.quantity-selector input');
        var qty = 1;
        if (inp) {
          var v = parseInt(inp.value, 10);
          if (!isNaN(v) && v > 0) qty = v;
        }
        ctrl.classList.toggle('boun-qty-gt-1', qty > 1);
      });
    }
    /* Listen for qty input changes (immediate flip before network round-trip) */
    document.addEventListener('input', function (e) {
      if (e.target && e.target.matches && e.target.matches('cart-drawer-component .cart-items .quantity-selector input')) {
        applyQtyButtonSwap();
      }
    }, true);
    document.addEventListener('change', function (e) {
      if (e.target && e.target.matches && e.target.matches('cart-drawer-component .cart-items .quantity-selector input')) {
        applyQtyButtonSwap();
      }
    }, true);
    document.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('cart-drawer-component .quantity-selector button')) {
        requestAnimationFrame(function () { applyQtyButtonSwap(); });
        setTimeout(applyQtyButtonSwap, 120);
        setTimeout(applyQtyButtonSwap, 320);
      }
    }, true);
    var bannerObserver = null;
    function attachBannerObserver() {
      var drawer = document.querySelector('cart-drawer-component');
      if (!drawer) {
        setTimeout(attachBannerObserver, 300);
        return;
      }
      if (bannerObserver) { try { bannerObserver.disconnect(); } catch (e) {} }
      bannerObserver = new MutationObserver(function (mutations) {
        /* Single-fire guard: pause observer while we apply, schedule
           via rAF to coalesce bursts of mutations, ignore pure
           character/style mutations. */
        if (window.__bounObsRunning) return;
        var meaningful = mutations.some(function (m) {
          if (m.type !== 'childList') return false;
          var nodes = Array.prototype.slice.call(m.addedNodes).concat(Array.prototype.slice.call(m.removedNodes));
          for (var i = 0; i < nodes.length; i++) {
            var n = nodes[i];
            if (n.nodeType !== 1) continue;
            if (n.classList && (
              n.classList.contains('boun-shipping-banner') ||
              n.classList.contains('boun-shipping-banner__msg') ||
              n.classList.contains('boun-shipping-banner__track') ||
              n.classList.contains('boun-shipping-banner__fill') ||
              n.classList.contains('boun-combo-bundle-row') ||
              n.classList.contains('boun-combo-hidden-row') ||
              n.classList.contains('boun-cart-totals-wrap') ||
              n.classList.contains('boun-cart-totals-strike') ||
              n.classList.contains('boun-cart-totals-final') ||
              n.classList.contains('boun-cart-shipping-row') ||
              n.classList.contains('boun-cart-shipping-label') ||
              n.classList.contains('boun-cart-shipping-value') ||
              n.classList.contains('boun-cart-count-badge')
            )) continue;
            /* Also ignore nodes whose tag is one of our injection children */
            if (n.tagName === 'SUP' && n.hasAttribute && n.hasAttribute('data-cart-count')) continue;
            if (n.tagName === 'S' || n.tagName === 'SPAN') {
              var p = n.parentElement;
              if (p && p.classList && p.classList.contains('boun-cart-totals-wrap')) continue;
            }
            return true;
          }
          return false;
        });
        if (!meaningful) return;
        if (window.__bounObsRunning) return;
        window.__bounObsRunning = true;
        try { bannerObserver.disconnect(); } catch (e) {}
        requestAnimationFrame(function () {
          try {
            reinsertCachedBanner();
            if (window.__bounLastCart) enhanceCartTotals(window.__bounLastCart);
            applyQtyButtonSwap(drawer);
            stripCentavos(drawer);
            applyColorSubtitle(drawer);
          } catch (e) { /* silent */ }
          try { bannerObserver.observe(drawer, { childList: true, subtree: true }); } catch (e) {}
          setTimeout(function () { window.__bounObsRunning = false; }, 100);
        });
      });
      bannerObserver.observe(drawer, { childList: true, subtree: true });
      applyQtyButtonSwap(drawer);
      stripCentavos(drawer);
      applyColorSubtitle(drawer);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', attachBannerObserver);
    } else {
      attachBannerObserver();
    }

    /* v119 — Loop-style cart totals:
       - Add "Shipping / Free" row above the subtotal
       - Replace "Total estimado" label with "Subtotal" + small count
       - Show original_total_price strikethrough + total_price red when
         there's a discount applied
       Built so it runs idempotently from refresh() + MutationObserver. */
    /* v120 — Per-variant compareAtPrice lookup so we can ALWAYS show a
       strikethrough "before" price on the subtotal, based on the variant
       compareAtPrice that already drives the "20% OFF / 25% OFF / 33% OFF"
       badges on the Shop product cards. */
    var BOUN_COMPARE_PRICES = {
      57034251862176: 10000000, // Sleep: compareAt $100.000
      57034252845216: 15000000, // Music: compareAt $150.000
      57034252517536: 6000000, // Swim: compareAt $60.000
      57034252779680: 10000000, // Moto: compareAt $100.000
      57034252910752: 3690000  // Industrial: compareAt $36.900
    };

    function calcCompareTotal(cart) {
      if (!cart || !cart.items) return 0;
      var compare = 0;
      cart.items.forEach(function (item) {
        var qty = item.quantity || 0;
        var compareUnit = BOUN_COMPARE_PRICES[item.variant_id] || item.original_price || item.price || 0;
        compare += compareUnit * qty;
      });
      return compare;
    }

    /* v184 — Compute the OPTIMISTIC combo discount: how much
       BOUNCOMBO{N} would discount the cart based on combo item qty,
       even if Shopify hasn't applied the code yet (e.g. dev tunnel
       blocks /discount/CODE with 401, or async race). Matches the
       discount shown on the combo bundle row. */
    function comboDiscountRateLocal(qty) {
      if (qty >= 5) return 25;
      if (qty === 4) return 20;
      if (qty === 3) return 15;
      if (qty === 2) return 10;
      return 0;
    }
    function calcOptimisticComboDiscount(cart) {
      if (!cart || !cart.items) return 0;
      var combos = {};
      cart.items.forEach(function (i) {
        var combo = i.properties && i.properties._combo;
        if (!combo) return;
        if (!combos[combo]) combos[combo] = { qty: 0, total: 0 };
        combos[combo].qty += i.quantity || 0;
        combos[combo].total += i.original_line_price || i.line_price || 0;
      });
      var discountAmount = 0;
      Object.keys(combos).forEach(function (k) {
        var c = combos[k];
        var rate = comboDiscountRateLocal(c.qty);
        if (rate > 0) {
          discountAmount += Math.round(c.total * rate / 100);
        }
      });
      return discountAmount;
    }

    function enhanceCartTotals(cart) {
      var drawer = document.querySelector('cart-drawer-component');
      if (!drawer || !cart) return;
      var totalRow = drawer.querySelector('.cart-totals__total');
      if (!totalRow) return;

      /* 1) Label: "Subtotal" + count badge */
      var labelEl = totalRow.querySelector('.cart-totals__total-label');
      if (labelEl) {
        var existingCountSpan = labelEl.querySelector('.boun-cart-count-badge');
        if (!existingCountSpan) {
          labelEl.innerHTML = 'Subtotal <sup class="boun-cart-count-badge" data-cart-count></sup>';
        }
        var countEl = labelEl.querySelector('[data-cart-count]');
        if (countEl) countEl.textContent = cart.item_count || 0;
      }

      /* 2) Total value: ALWAYS show compareAt strikethrough + red final
         if there's any saving (compareAt > final). Falls back to single
         price only if compareTotal === total (no savings).

         v184 — If Shopify hasn't applied the combo discount yet (dev
         tunnel 401, or async timing), subtract the expected combo
         discount visually so the subtotal stays consistent with the
         per-combo bundle-row -25% badge. When Shopify DOES apply the
         code, cart.total_discount > 0 and we use the real total. */
      var valueEl = totalRow.querySelector('.cart-totals__total-value');
      if (valueEl) {
        var compareTotal = calcCompareTotal(cart);
        var rawTotal = cart.total_price || 0;
        var optimisticComboDiscount = calcOptimisticComboDiscount(cart);
        var alreadyDiscounted = (cart.total_discount || 0) >= optimisticComboDiscount;
        var finalTotal = alreadyDiscounted
          ? rawTotal
          : rawTotal - optimisticComboDiscount;
        var hasSavings = compareTotal > finalTotal;
        var wrapper = totalRow.querySelector('.boun-cart-totals-wrap');
        if (!wrapper) {
          wrapper = document.createElement('span');
          wrapper.className = 'boun-cart-totals-wrap';
          valueEl.style.display = 'none';
          totalRow.appendChild(wrapper);
        }
        if (hasSavings) {
          wrapper.innerHTML = '<s class="boun-cart-totals-strike" data-orig></s><span class="boun-cart-totals-final" data-final></span>';
          var origEl = wrapper.querySelector('[data-orig]');
          var finalEl = wrapper.querySelector('[data-final]');
          if (origEl) origEl.textContent = fmt(compareTotal);
          if (finalEl) finalEl.textContent = fmt(finalTotal);
        } else {
          wrapper.innerHTML = '<span class="boun-cart-totals-final" data-final></span>';
          var finalEl2 = wrapper.querySelector('[data-final]');
          if (finalEl2) finalEl2.textContent = fmt(finalTotal);
        }
      }

      /* 3) Add "Shipping / Free" row above the subtotal */
      var container = totalRow.closest('.cart-totals__container');
      if (container && !container.querySelector('.boun-cart-shipping-row')) {
        var shippingRow = document.createElement('div');
        shippingRow.className = 'boun-cart-shipping-row';
        shippingRow.innerHTML = '<span class="boun-cart-shipping-label">Envío</span><span class="boun-cart-shipping-value">Calculado al pagar</span>';
        /* Show "Gratis" if cart total ≥ free shipping threshold */
        if ((cart.total_price || 0) >= FREE_SHIPPING_THRESHOLD) {
          shippingRow.querySelector('.boun-cart-shipping-value').textContent = 'Gratis';
        }
        container.insertBefore(shippingRow, totalRow);
      } else if (container) {
        var existingShipping = container.querySelector('.boun-cart-shipping-row .boun-cart-shipping-value');
        if (existingShipping) {
          existingShipping.textContent = (cart.total_price || 0) >= FREE_SHIPPING_THRESHOLD ? 'Gratis' : 'Calculado al pagar';
        }
      }
    }

    function relabelTitle() {
      var titleEl = document.querySelector('cart-drawer-component .cart-drawer__heading');
      if (!titleEl) return;
      /* Replace only the text node — keep the bubble + count span intact */
      var nodes = Array.prototype.slice.call(titleEl.childNodes);
      for (var i = 0; i < nodes.length; i++) {
        var n = nodes[i];
        if (n.nodeType === 3) {
          var trimmed = (n.textContent || '').trim();
          if (trimmed && /^carrito$/i.test(trimmed)) {
            n.textContent = TITLE_TEXT;
            return;
          }
          if (trimmed && !/(\d)/.test(trimmed)) {
            n.textContent = TITLE_TEXT;
            return;
          }
        }
      }
    }

    /* v113 — guarded refresh:
       - debounced (max 1 call per 200ms)
       - sets __bounRefreshing flag so MutationObserver inside refresh
         is suppressed (avoids infinite loop: banner insert → mutation
         → refresh → banner insert → ...)
       - bails out if drawer dialog is closed (no need to update UI) */
    var refreshTimer = null;
    var lastRefresh = 0;
    window.__bounRefreshing = false;
    function refresh() {
      var now = Date.now();
      if (window.__bounRefreshing) return;
      if (now - lastRefresh < 200) {
        clearTimeout(refreshTimer);
        refreshTimer = setTimeout(refresh, 200 - (now - lastRefresh));
        return;
      }
      lastRefresh = now;
      window.__bounRefreshing = true;
      /* v190 — Synchronous pre-render BEFORE the /cart.js fetch so
         the carousel is in DOM immediately, even on the very first
         page load. Uses fakeCart (empty items + non-zero count) to
         pass the empty check; pickRelated returns the full shuffled
         catalog. The async branch below re-renders with real cart
         data once /cart.js resolves. */
      try {
        var fake = window.__bounLastCart || { items: [], item_count: 1 };
        window.__bounRelatedSkipEmptyCheck = true;
        renderRelatedProducts(fake);
        window.__bounRelatedSkipEmptyCheck = false;
      } catch (e) { /* silent */ }
      fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (cart) {
          if (!cart) return;
          ensureBanner(cart);
          relabelTitle();
          enhanceCartTotals(cart);
          renderRelatedProducts(cart);
          stripCentavos();
          applyColorSubtitle();
          window.__bounLastCart = cart;
        })
        .catch(function () { /* silent */ })
        .finally(function () {
          /* Release flag after the next paint so MutationObserver
             callbacks scheduled by THIS refresh's DOM mutations don't
             re-enter refresh. */
          setTimeout(function () { window.__bounRefreshing = false; }, 80);
        });
    }

    /* v126 — Related products carousel below cart items.
       Reads window.__bounCatalog (injected by Liquid), filters out
       items already in the cart, shuffles, and renders Loop-style
       cards with an "Añadir" action. */
    function fmtCurrency(cents) {
      var n = Math.round((cents || 0) / 100);
      try {
        return new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP', maximumFractionDigits: 0 }).format(n);
      } catch (e) { return '$' + n.toLocaleString('es-CO'); }
    }
    /* v264 — map a dB label ("-45dB", "Impermeable") to its isolation-tier class
       so the carousel pill colour matches the rest of the site. */
    function dbTier(label) {
      var n = parseInt(String(label || '').replace(/[^0-9]/g, ''), 10) || 0;
      if (n === 0) return 'tn';
      if (n <= 14) return 't1';
      if (n <= 25) return 't2';
      if (n <= 36) return 't3';
      return 't4';
    }
    function shuffleArray(arr) {
      var a = arr.slice();
      for (var i = a.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var t = a[i]; a[i] = a[j]; a[j] = t;
      }
      return a;
    }
    function pickRelated(cart) {
      /* v264 — Hide sold-out products from the cart-drawer carousel.
         A product is considered in stock when:
           - it has a positive raw inventoryQty, OR
           - inventoryQty is null/undefined (untracked variant) AND Shopify
             reports it as available.
         This ensures BOUN lines we manually drop to 0 in Shopify Admin
         disappear from "Te podría gustar" without us having to touch JS. */
      var catalog = (window.__bounCatalog || []).filter(function (p) {
        if (!p || !p.variantId) return false;
        var qty = (typeof p.inventoryQty === 'number') ? p.inventoryQty : null;
        if (qty !== null) return qty > 0;
        return p.available !== false;
      });
      if (catalog.length === 0) return [];
      var inCartVariants = {};
      (cart.items || []).forEach(function (it) { inCartVariants[it.variant_id] = true; });
      var inCartCats = {};
      (cart.items || []).forEach(function (it) {
        var match = catalog.filter(function (p) { return p.variantId === it.variant_id; })[0];
        if (match && match.category) inCartCats[match.category] = true;
      });
      /* v132 — always return the full catalog ordered by:
         1) Same-category (best contextual match), shuffled
         2) Other categories not in cart, shuffled
         3) Products already in cart, shuffled (so customer can re-add)
         The carousel never disappears even when every product is in the cart. */
      var sameCatNotInCart = catalog.filter(function (p) {
        return inCartCats[p.category] && !inCartVariants[p.variantId];
      });
      var sameCatIds = {};
      sameCatNotInCart.forEach(function (p) { sameCatIds[p.variantId] = true; });
      var otherNotInCart = catalog.filter(function (p) {
        return !inCartVariants[p.variantId] && !sameCatIds[p.variantId];
      });
      var alreadyInCart = catalog.filter(function (p) {
        return inCartVariants[p.variantId];
      });
      var pool = shuffleArray(sameCatNotInCart)
        .concat(shuffleArray(otherNotInCart))
        .concat(shuffleArray(alreadyInCart));
      return pool.slice(0, 6);
    }
    function renderRelatedProducts(cart) {
      var drawer = document.querySelector('cart-drawer-component');
      if (!drawer) return;
      var content = drawer.querySelector('.cart-drawer__content') || drawer;
      var existing = drawer.querySelector('.boun-related');
      /* v190 — Skip the isCartDrawerEmpty check during pre-render so
         the carousel always gets built immediately on page load. The
         later refresh() will re-render with real cart-aware sorting. */
      var cartEmpty = !cart || !cart.item_count || cart.item_count <= 0;
      if (!window.__bounRelatedSkipEmptyCheck) {
        cartEmpty = cartEmpty || isCartDrawerEmpty(drawer);
      }
      if (cartEmpty) {
        if (existing && existing.parentNode) existing.parentNode.removeChild(existing);
        return;
      }
      var related = pickRelated(cart);
      if (related.length === 0) {
        if (existing && existing.parentNode) existing.parentNode.removeChild(existing);
        return;
      }
      var container = existing;
      if (!container) {
        container = document.createElement('div');
        container.className = 'boun-related';
        container.innerHTML = ''
          + '<div class="boun-related__head">'
          + '  <h3 class="boun-related__title">Te podría gustar</h3>'
          + '  <div class="boun-related__nav">'
          + '    <button type="button" class="boun-related__btn" data-related-prev aria-label="Anterior">'
          + '      <svg viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.75 3.5L5.25 7l3.5 3.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>'
          + '    </button>'
          + '    <button type="button" class="boun-related__btn" data-related-next aria-label="Siguiente">'
          + '      <svg viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.25 3.5L8.75 7l-3.5 3.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>'
          + '    </button>'
          + '  </div>'
          + '</div>'
          + '<div class="boun-related__track" data-related-track></div>'
          + '<div class="boun-related__progress" data-related-progress aria-hidden="true"><div class="boun-related__progress-fill" data-related-progress-fill></div></div>';
      }
      /* v129 — Insert INSIDE the scrollable items area so the carousel
         scrolls together with cart items. Previously it sat between the
         scroll area and the sticky summary, eating vertical space and
         hiding cart items above the fold. */
      var itemsScroll = drawer.querySelector('.cart-drawer__items');
      var itemsWrapper = drawer.querySelector('.cart-items__wrapper');
      var summaryEl = drawer.querySelector('.cart-drawer__summary, .cart-drawer__footer');
      var desiredParent = itemsScroll || (summaryEl && summaryEl.parentNode) || content;
      var desiredAnchor = null;
      if (itemsScroll && itemsWrapper && itemsWrapper.parentNode === itemsScroll) {
        desiredAnchor = itemsWrapper.nextSibling;
      }
      /* v171 — Only re-insert if container is actually orphaned or
         in the WRONG parent. Skip re-positioning if it's already
         attached anywhere inside the drawer scroll area, otherwise
         moving the node (even to the same slot) triggers a
         removed+added pair that the user sees as a flicker. */
      var inDrawerScope = desiredParent && desiredParent.contains && desiredParent.contains(container);
      if (!inDrawerScope) {
        if (desiredParent) {
          if (desiredAnchor) {
            desiredParent.insertBefore(container, desiredAnchor);
          } else {
            desiredParent.appendChild(container);
          }
        }
      }
      var track = container.querySelector('[data-related-track]');
      if (!track) return;
      /* v171 — Skip rebuilding the cards while the add-to-cart flow
         is in flight. Prevents the carousel from flickering as the
         morph + cart:refresh both fire in the same tick. */
      if (window.__bounRelatedSkipRebuild && track.children.length > 0) {
        return;
      }
      track.innerHTML = related.map(function (p) {
        var price = fmtCurrency(p.price);
        /* v155 — color from product's own metafield (set in Shopify Admin);
           fallback to Negro/#0A0A0A so existing BOUN earplugs (all black)
           display correctly. */
        var colorName = p.colorName || 'Negro';
        var colorHex  = p.colorHex  || '#0A0A0A';
        /* v159 — category accent color used as a subtle top stripe on
           the card, matching Shop's per-category accent pattern. */
        var catAccent = (window.__bounCategoryAccent || {})[p.category] || '#252427';
        /* Multi-category stripe colors from the product's category pills:
           c1=primary, c2/c3 fall back so single-category renders solid. */
        var pcats = p.cats || [];
        var c1 = (pcats[0] && pcats[0].c) || catAccent;
        var c2 = (pcats[1] && pcats[1].c) || c1;
        var c3 = (pcats[2] && pcats[2].c) || c2;
        var stripeOp = pcats.length > 1 ? '0.95' : '0.35';
        /* 3+ categories (e.g. Music) use the tri-band stripe; 2-category cards
           (e.g. Moto) fall through to the even 50/50 split. */
        var triCls = pcats.length >= 3 ? ' is-tri-cat' : '';
        var cardStyle = '--cat-accent: ' + c1 + '; --cat-accent2: ' + c2 + '; --cat-accent3: ' + c3 + '; --cat-stripe-op: ' + stripeOp + ';';
        return ''
          + '<article class="boun-related-card' + triCls + '" data-related-variant="' + p.variantId + '" style="' + cardStyle + '">'
          + '  <a class="boun-related-card__media" href="' + p.url + '">'
          + '    <img src="' + p.image + '" alt="' + (p.title || '').replace(/"/g, '&quot;') + '" loading="lazy">'
          + '  </a>'
          + '  <div class="boun-related-card__body">'
          + '    <div class="boun-related-card__title-row">'
          + '      <h4 class="boun-related-card__title">' + p.title + '</h4>'
          + '      <span class="boun-related-card__color-swatch" aria-label="' + colorName + '" style="background:' + colorHex + ';"></span>'
          + '    </div>'
          + ((p.dbs && p.dbs.length) ? '<div class="boun-related-card__dbs">' + p.dbs.map(function (d) { return '<span class="boun-related-card__db boun-db--' + dbTier(d.l) + '">' + d.l + '</span>'; }).join('') + '</div>' : '')
          + ((p.cats && p.cats.length) ? '<div class="boun-related-card__cats">' + p.cats.map(function (c) { return '<span class="boun-related-card__cat-pill" style="--cp:' + c.c + ';">' + c.l + '</span>'; }).join('') + '</div>' : '')
          + '  </div>'
          + '  <div class="boun-related-card__action">'
          + '    <button type="button" class="boun-related-card__add" data-related-add="' + p.variantId + '">Añadir<span class="boun-related-card__add-price">+ ' + price + '</span></button>'
          + '  </div>'
          + '</article>';
      }).join('');
      /* Wire arrow nav with snap-to-card scroll amounts */
      var prevBtn = container.querySelector('[data-related-prev]');
      var nextBtn = container.querySelector('[data-related-next]');
      var stepWidth = function () {
        var card = track.querySelector('.boun-related-card');
        if (!card) return track.offsetWidth;
        var styles = getComputedStyle(track);
        var gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
        return card.getBoundingClientRect().width + gap;
      };
      var progressFill = container.querySelector('[data-related-progress-fill]');
      var progressBar = container.querySelector('[data-related-progress]');
      var updateNavState = function () {
        var max = track.scrollWidth - track.clientWidth - 2;
        if (prevBtn) prevBtn.toggleAttribute('disabled', track.scrollLeft <= 2);
        if (nextBtn) nextBtn.toggleAttribute('disabled', track.scrollLeft >= max);
        if (progressFill && progressBar) {
          var scrollable = track.scrollWidth - track.clientWidth;
          if (scrollable <= 4) {
            progressBar.style.display = 'none';
          } else {
            progressBar.style.display = '';
            var visiblePct = Math.max(15, (track.clientWidth / track.scrollWidth) * 100);
            var pos = scrollable > 0 ? (track.scrollLeft / scrollable) * (100 - visiblePct) : 0;
            progressFill.style.width = visiblePct + '%';
            progressFill.style.transform = 'translateX(' + (pos / visiblePct) * 100 + '%)';
          }
        }
      };
      if (prevBtn && !prevBtn.__bounWired) {
        prevBtn.addEventListener('click', function () {
          track.scrollBy({ left: -stepWidth(), behavior: 'smooth' });
        });
        prevBtn.__bounWired = true;
      }
      if (nextBtn && !nextBtn.__bounWired) {
        nextBtn.addEventListener('click', function () {
          track.scrollBy({ left: stepWidth(), behavior: 'smooth' });
        });
        nextBtn.__bounWired = true;
      }
      if (!track.__bounScrollWired) {
        track.addEventListener('scroll', updateNavState, { passive: true });
        track.__bounScrollWired = true;
      }
      updateNavState();
    }
    /* v171 — Add-to-cart from a related card using Horizon's native flow.
       Why this works: we POST /cart/add.js with `sections=<id>` so
       Shopify returns the freshly rendered cart-items section HTML
       atomically. Then we dispatch a CartAddEvent — the same event
       Horizon's product-form fires — and Horizon's component-cart-items
       morphs itself with `morphSection(...)`. The drawer's
       <cart-drawer-component> listens for that event and opens itself.
       No DOM swap, no innerHTML replace, no race window.

       Flicker fix (v171): before dispatching, detach the .boun-related
       carousel from the DOM and stash the node. The morph would
       otherwise wipe it because the server's section HTML doesn't
       include the carousel. Re-insert the SAME node immediately after
       the morph so the user never sees it leave. */
    document.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest && e.target.closest('[data-related-add]');
      if (!btn) return;
      e.preventDefault();
      var variantId = btn.getAttribute('data-related-add');
      if (!variantId) return;
      if (btn.disabled) return;
      btn.disabled = true;
      var originalLabel = btn.textContent;
      btn.textContent = '…';

      /* Collect every cart-items-component section id currently in
         the DOM. The drawer's nested cart-items has the parent
         header section id. */
      var sectionIds = [];
      document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (el) {
        var id = el.getAttribute('data-section-id');
        if (id && sectionIds.indexOf(id) === -1) sectionIds.push(id);
      });

      /* Open the drawer immediately so the user sees feedback while
         the network request lands. Horizon will refresh the items
         content in place via the CartAddEvent below. */
      var drawer = document.querySelector('cart-drawer-component');
      try { drawer && typeof drawer.open === 'function' && drawer.open(); }
      catch (eOpen) { /* silent */ }

      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          items: [{ id: parseInt(variantId, 10), quantity: 1 }],
          sections: sectionIds.join(',')
        })
      })
      .then(function (r) { return r.json(); })
      .then(function (addResponse) {
        /* v171 — Detach the carousel BEFORE dispatch so the morph
           can't wipe it. Stash the original parent + sibling so we
           can re-insert it back to the exact same DOM position. */
        var savedCarousel = drawer ? drawer.querySelector('.boun-related') : null;
        var savedParent = null;
        var savedNext = null;
        if (savedCarousel && savedCarousel.parentNode) {
          savedParent = savedCarousel.parentNode;
          savedNext = savedCarousel.nextSibling;
          savedCarousel.parentNode.removeChild(savedCarousel);
        }
        /* Set a flag so renderRelatedProducts knows not to rebuild
           the cards during this short window. */
        window.__bounRelatedSkipRebuild = true;

        /* The /cart/add.js response with `sections` returns
           { items:[...], sections: { <sectionId>: '<html>' } }.
           Pass it to a CartAddEvent — Horizon's
           component-cart-items will morph itself. */
        var ev = new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: addResponse,
            sourceId: 'boun-related-add',
            data: {
              source: 'boun-related-add',
              itemCount: 1,
              variantId: variantId,
              sections: addResponse && addResponse.sections ? addResponse.sections : {}
            }
          }
        });
        document.dispatchEvent(ev);

        /* Re-insert the saved carousel node into the new items
           wrapper. Try to use the original parent if it's still
           connected; otherwise find the new .cart-drawer__items
           and append there. */
        if (savedCarousel) {
          var dst = (savedParent && savedParent.isConnected)
            ? savedParent
            : (drawer && drawer.querySelector('.cart-drawer__items'));
          if (dst) {
            if (savedNext && savedNext.parentNode === dst) {
              dst.insertBefore(savedCarousel, savedNext);
            } else {
              dst.appendChild(savedCarousel);
            }
          }
        }

        /* Also fire our custom events so the combo-grouping JS in
           boun-combo-cart.liquid re-runs and groups correctly. */
        document.dispatchEvent(new Event('cart:refresh'));
        document.dispatchEvent(new Event('cart:updated'));

        /* Allow rebuilds again after a moment (renderRelatedProducts
           may want to re-render if the related selection changed). */
        setTimeout(function () { window.__bounRelatedSkipRebuild = false; }, 600);

        /* Re-fetch full cart to keep window.__bounLastCart and the
           BOUN combo grouping in sync. */
        return fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            window.__bounLastCart = cart;
            document.dispatchEvent(new Event('cart:refresh'));
          });
      })
      .catch(function () {
        btn.textContent = originalLabel;
        btn.disabled = false;
      })
      .then(function () {
        /* Restore button label whether the morph succeeded or not. */
        btn.textContent = originalLabel;
        btn.disabled = false;
      });
    });

    /* v138 — pre-render the carousel immediately using the catalog only
       (cart-agnostic). This eliminates the wait for /cart.js so the
       carousel is in the DOM before the user can even click the cart
       icon. refresh() will re-render with cart-aware sorting once
       /cart.js resolves. */
    /* v190 — Aggressive pre-render so the carousel is in DOM before
       the user opens the drawer. The previous version called
       renderRelatedProducts with a fake cart, but that function
       bails out via isCartDrawerEmpty if the drawer's items area
       isn't fully populated yet. Now we:
         1) Bypass the empty-drawer check with a flag.
         2) Retry at 0, 100ms, 400ms so we catch the drawer no matter
            when its items area finishes hydrating.
         3) The carousel sits hidden behind the closed drawer; when
            the user opens it, the carousel is already there. */
    function preRenderRelatedProducts() {
      var drawer = document.querySelector('cart-drawer-component');
      if (!drawer) return;
      if (drawer.querySelector('.boun-related .boun-related-card')) return; /* already rendered */
      var fakeCart = window.__bounLastCart || { items: [], item_count: 1 };
      window.__bounRelatedSkipEmptyCheck = true;
      try { renderRelatedProducts(fakeCart); } catch (e) { /* silent */ }
      window.__bounRelatedSkipEmptyCheck = false;
    }
    function init() {
      preRenderRelatedProducts();
      refresh();
      /* Retry pre-render at increasing delays in case the drawer's
         items area wasn't fully hydrated on the first try. */
      setTimeout(preRenderRelatedProducts, 100);
      setTimeout(preRenderRelatedProducts, 400);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    /* v173 — Capture-phase listener that preserves the related
       carousel through Horizon's morph. Any time a cart:update is
       dispatched (qty +/-, line remove, etc.), Horizon's
       component-cart-items morphs the cart section, which wipes
       the .boun-related node because the server's HTML doesn't
       include it. We detach the node in the CAPTURE phase (runs
       before Horizon's bubble-phase handler), then queue a
       microtask to re-attach it once the synchronous morph
       finishes. The carousel never leaves the DOM tree for a
       paintable frame, so the user sees no flicker. */
    document.addEventListener('cart:update', function (e) {
      /* Skip our own flows — boun-related-add and boun-combo-qty
         already handle the detach + reattach in their own click
         handlers, so we'd double-handle here. */
      if (e && e.detail) {
        var src = e.detail.sourceId || (e.detail.data && e.detail.data.source);
        if (src === 'boun-related-add' || src === 'boun-combo-qty') return;
      }

      var drawer = document.querySelector('cart-drawer-component');
      if (!drawer) return;
      var carousel = drawer.querySelector('.boun-related');
      if (!carousel || !carousel.parentNode) return;

      var savedParent = carousel.parentNode;
      var savedNext = carousel.nextSibling;
      savedParent.removeChild(carousel);

      window.__bounRelatedSkipRebuild = true;

      /* Microtask: runs AFTER all synchronous handlers (including
         Horizon's morphSection call) complete. Re-attach the
         carousel into the freshly-morphed items area. */
      Promise.resolve().then(function () {
        var dst = (savedParent && savedParent.isConnected)
          ? savedParent
          : (drawer && drawer.querySelector('.cart-drawer__items'));
        if (!dst) return;
        if (savedNext && savedNext.parentNode === dst) {
          dst.insertBefore(carousel, savedNext);
        } else {
          dst.appendChild(carousel);
        }
        /* Release the rebuild lock after enough time for any
           debounced refresh() to finish. */
        setTimeout(function () { window.__bounRelatedSkipRebuild = false; }, 600);
      });
    }, true);

    /* Re-run on cart change events */
    document.addEventListener('cart:refresh', refresh);
    document.addEventListener('cart:updated', refresh);
    document.addEventListener('shopify:cart:update', refresh);
    /* v180 — Also re-run after Horizon's cart:update (fired by the
       native qty +/- on individual products + our combo pill). Without
       this, our BOUN totals (count badge, compareAt strikethrough,
       red final, shipping row) stay stale after the morph because
       enhanceCartTotals only runs from refresh(). Use a short
       setTimeout so the morph completes before we re-decorate. */
    document.addEventListener('cart:update', function () {
      setTimeout(refresh, 60);
    });
    /* Re-run when drawer opens */
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-testid="cart-drawer-trigger"], a[href$="/cart"], button[aria-label*="Carrito" i]')) {
        setTimeout(refresh, 150);
        setTimeout(refresh, 600);
      }
    });
    /* v113 — Removed MutationObserver. It was creating an infinite
       refresh loop: ensureBanner inserts the banner element → mutation
       fires observer → schedules refresh → ensureBanner runs again →
       re-inserts banner → infinite loop. The cart:refresh / cart:updated
       events already cover the necessary re-renders. */
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["boun-product-page"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initOne(root) {
      if (!root || root.__bpInit) return;
      root.__bpInit = true;

      /* v278 — selector real de variantes por color: al click cambia el id
         del formulario de compra, el botón de combo y el nombre mostrado.
         v279 — si la variante tiene foto propia (data-bp-vimg, p. ej. Sleep
         Lila), el hero de la galería cambia a esa foto; al volver a una
         variante sin foto se restaura el hero original. */
      var swWrap = root.querySelector('[data-bp-swatches]');
      if (swWrap) {
        var swInput = root.querySelector('[data-bp-form] input[name="id"]');
        var swName = root.querySelector('[data-bp-color-name]');
        var swCombo = root.querySelector('[data-bp-combo-add]');
        var swHero = root.querySelector('.bp-hero-img');
        var swHeroSrc = swHero ? swHero.getAttribute('src') : null;
        swWrap.addEventListener('click', function (e) {
          var btn = e.target.closest('.bp-swatch');
          if (!btn || btn.disabled || !btn.hasAttribute('data-bp-variant')) return;
          swWrap.querySelectorAll('.bp-swatch').forEach(function (b) {
            var on = b === btn;
            b.classList.toggle('is-active', on);
            b.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
          if (swInput) swInput.value = btn.getAttribute('data-bp-variant');
          if (swName) swName.textContent = btn.getAttribute('data-bp-vtitle');
          if (swCombo) swCombo.setAttribute('data-bp-combo-add', btn.getAttribute('data-bp-variant'));
          if (swHero) {
            var vimg = btn.getAttribute('data-bp-vimg');
            var next = vimg || swHeroSrc;
            if (next && swHero.getAttribute('src') !== next) swHero.setAttribute('src', next);
          }
          /* v280 — galería por variante: mostrar solo los slides cuyo
             data-bp-var coincide con la variante elegida y reconstruir
             los dots del carrusel móvil. */
          var vt = (btn.getAttribute('data-bp-vtitle') || '').trim().toLowerCase();
          var varItems = root.querySelectorAll('.bp-gallery-item[data-bp-var]');
          if (varItems.length && vt) {
            varItems.forEach(function (it) {
              it.classList.toggle('bp-var-hide', it.getAttribute('data-bp-var') !== vt);
            });
            if (root.__bpRebuildDots) root.__bpRebuildDots();
          }
        });
      }

      /* v269 — ML-style quantity dropdown (replaces the −/+ stepper). The
         chosen value is written to the hidden [data-bp-qty-value] input so the
         add-to-cart FormData picks it up. */
      var qtyBox = root.querySelector('[data-bp-qtybox]');
      var qtyValue = root.querySelector('[data-bp-qty-value]');
      if (qtyBox && qtyValue) {
        var qtyToggle = qtyBox.querySelector('[data-bp-qty-toggle]');
        var qtyMenu = qtyBox.querySelector('[data-bp-qty-menu]');
        var qtyDisplay = qtyBox.querySelector('[data-bp-qty-display]');
        var qtyOpts = qtyBox.querySelectorAll('[data-bp-qty-opt]');
        var closeQtyMenu = function () {
          qtyBox.classList.remove('is-open');
          if (qtyMenu) qtyMenu.hidden = true;
          if (qtyToggle) qtyToggle.setAttribute('aria-expanded', 'false');
        };
        if (qtyToggle) {
          qtyToggle.addEventListener('click', function (e) {
            e.stopPropagation();
            if (qtyBox.classList.contains('is-open')) {
              closeQtyMenu();
            } else {
              qtyBox.classList.add('is-open');
              if (qtyMenu) qtyMenu.hidden = false;
              qtyToggle.setAttribute('aria-expanded', 'true');
            }
          });
        }
        qtyOpts.forEach(function (opt) {
          opt.addEventListener('click', function (e) {
            e.stopPropagation();
            var v = parseInt(opt.getAttribute('data-bp-qty-opt'), 10) || 1;
            qtyValue.value = v;
            if (qtyDisplay) qtyDisplay.textContent = v;
            qtyOpts.forEach(function (o) {
              var sel = o === opt;
              o.classList.toggle('is-selected', sel);
              o.setAttribute('aria-selected', sel ? 'true' : 'false');
            });
            closeQtyMenu();
          });
        });
        document.addEventListener('click', function (e) {
          if (qtyBox.classList.contains('is-open') && !qtyBox.contains(e.target)) closeQtyMenu();
        });
        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape') closeQtyMenu();
        });
      }

      var form = root.querySelector('[data-bp-form]');
      if (form) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          var btn = form.querySelector('.bp-cart-btn');
          var label = btn ? btn.querySelector('.bp-cart-label') : null;
          var originalText = label ? label.textContent : 'Añadir al carrito';
          if (btn) {
            btn.classList.remove('is-added', 'is-error');
            btn.classList.add('is-loading');
            if (label) label.textContent = 'Añadiendo…';
          }
          var formData = new FormData(form);
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: formData
          })
            .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
            .then(function () {
              if (btn) {
                btn.classList.remove('is-loading');
                btn.classList.add('is-added');
                if (label) label.textContent = '✓ Añadido';
              }
              document.dispatchEvent(new CustomEvent('cart:refresh'));
              document.dispatchEvent(new CustomEvent('cart-update'));
              /* v83 — Open the cart drawer in place so the user immediately
                 sees what was added (Loop pattern). */
              if (typeof window.openBounCartDrawer === 'function') {
                window.openBounCartDrawer();
              }
              setTimeout(function () {
                if (btn) btn.classList.remove('is-added');
                if (label) label.textContent = originalText;
              }, 2400);
            })
            .catch(function () {
              if (btn) {
                btn.classList.remove('is-loading');
                btn.classList.add('is-error');
                if (label) label.textContent = 'Error · Reintentar';
              }
              setTimeout(function () {
                if (btn) btn.classList.remove('is-error');
                if (label) label.textContent = originalText;
              }, 2400);
            });
        });
      }

      /* v60 — "Añadir al combo" button: stage the variant id in
         localStorage and redirect to the combo builder page with
         the current line as the from-source query param. */
      var comboBtn = root.querySelector('[data-bp-combo-add]');
      if (comboBtn) {
        comboBtn.addEventListener('click', function (e) {
          e.preventDefault();
          var id = comboBtn.getAttribute('data-bp-combo-add');
          var line = comboBtn.getAttribute('data-line') || '';
          var lbl = comboBtn.querySelector('.bp-combo-label');
          comboBtn.classList.add('is-added');
          if (lbl) lbl.textContent = '✓ Yendo al combo…';
          try {
            var stage = JSON.parse(localStorage.getItem('boun-combo-stage') || '[]');
            if (stage.indexOf(id) === -1) stage.push(id);
            localStorage.setItem('boun-combo-stage', JSON.stringify(stage));
          } catch (err) {}
          window.location.href = '/pages/arma-tu-combo?from=' + encodeURIComponent(line || 'product');
        });
      }

    }

    function initGalleryDots(root) {
      if (!root || root.__bpDotsInit) return;
      root.__bpDotsInit = true;

      var gallery = root.querySelector('.bp-gallery');
      var dotsContainer = root.querySelector('[data-bp-dots]');
      if (!gallery || !dotsContainer) return;

      /* Pause/play videos based on visibility so we don't burn CPU/data on
         videos that aren't on screen (Loop-style behavior). */
      var videos = gallery.querySelectorAll('.bp-gallery-video');
      if (videos.length) {
        var vIo = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.intersectionRatio > 0.5) {
              var pp = entry.target.play();
              if (pp && pp.catch) pp.catch(function () {});
            } else {
              entry.target.pause();
            }
          });
        }, { root: gallery, threshold: [0, 0.5, 1] });
        videos.forEach(function (v) { vIo.observe(v); });
      }

      /* v280 — build() reconstruible: recolecta solo paneles VISIBLES (excluye
         .bp-var-hide de la variante no seleccionada) y rehace dots + observer.
         Expuesto como root.__bpRebuildDots para llamarlo al cambiar variante. */
      function build() {
        if (root.__bpDotsIO) { root.__bpDotsIO.disconnect(); root.__bpDotsIO = null; }

        /* Collect gallery panels in visual order: hero first, then items */
        var items = [];
        var hero = gallery.querySelector('.bp-hero-frame');
        if (hero) items.push(hero);
        gallery.querySelectorAll('.bp-gallery-item').forEach(function (it) {
          if (!it.classList.contains('bp-var-hide')) items.push(it);
        });
        dotsContainer.innerHTML = '';
        if (items.length < 2) return;

        /* Render dots */
        items.forEach(function (item, i) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'bp-gallery-dot' + (i === 0 ? ' is-active' : '');
          dot.setAttribute('aria-label', 'Ver foto ' + (i + 1));
          dot.setAttribute('role', 'tab');
          dot.addEventListener('click', function () {
            item.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
          });
          dotsContainer.appendChild(dot);
        });
        var dots = dotsContainer.querySelectorAll('.bp-gallery-dot');

        /* Update active dot as the user swipes through the carousel */
        var io = new IntersectionObserver(function (entries) {
          var best = null;
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              if (!best || entry.intersectionRatio > best.intersectionRatio) best = entry;
            }
          });
          if (best) {
            var idx = items.indexOf(best.target);
            if (idx === -1) return;
            dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
          }
        }, { root: gallery, threshold: [0.5, 0.75, 0.9] });
        items.forEach(function (item) { io.observe(item); });
        root.__bpDotsIO = io;
      }

      build();
      root.__bpRebuildDots = build;
    }

    /* v56 — On desktop, relocate the .boun-reviews--product section into
       the right column under the info card. We wrap .bp-info AND the
       reviews in a single .bp-right-col container so they're ONE grid
       item — avoids overlap from sticky info + separate grid rows.
       On mobile (< 1024px) reviews stays in its original full-width
       position below the unified cream block. */
    function relocateReviewsOnDesktop(root) {
      if (!root || root.__bpReviewsRelocated) return;
      if (window.innerWidth < 1024) return;

      var reviewsSection = document.querySelector('[id*="boun_product_reviews"]');
      if (!reviewsSection) return;

      var info = root.querySelector('.bp-info');
      var grid = root.querySelector('.bp-grid');
      if (!info || !grid || !info.parentNode) return;

      /* Wrap .bp-info in a .bp-right-col container, then append reviews */
      var rightCol = grid.querySelector('.bp-right-col');
      if (!rightCol) {
        rightCol = document.createElement('div');
        rightCol.className = 'bp-right-col';
        info.parentNode.insertBefore(rightCol, info);
        rightCol.appendChild(info);
      }
      rightCol.appendChild(reviewsSection);
      reviewsSection.classList.add('bp-reviews-relocated');
      root.__bpReviewsRelocated = true;

      /* v69 — Move the accordion right after the relocated reviews so it
         stays in the right column on desktop. */
      var acc = root.querySelector('[data-bp-accordion]');
      if (acc && reviewsSection.parentNode) {
        reviewsSection.insertAdjacentElement('afterend', acc);
      }
    }

    /* v69 — On mobile (where reviews stays in its original Shopify section
       position), move the accordion to appear AFTER the reviews. */
    function relocateAccordionOnMobile(root) {
      if (!root || root.__bpAccRelocatedMobile) return;
      if (window.innerWidth >= 1024) return;
      var acc = root.querySelector('[data-bp-accordion]');
      var reviews = document.querySelector('[id*="boun_product_reviews"]');
      if (!acc || !reviews) return;
      reviews.insertAdjacentElement('afterend', acc);
      root.__bpAccRelocatedMobile = true;
    }

    function init() {
      document.querySelectorAll('[data-bp-page]').forEach(function (root) {
        initOne(root);
        initGalleryDots(root);
        relocateReviewsOnDesktop(root);
        relocateAccordionOnMobile(root);
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["boun-product-related"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function syncComboButtons(root) {
      var STORAGE_KEY = 'boun-combo';
      var combo;
      try { combo = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); } catch (e) { combo = []; }
      root.querySelectorAll('[data-combo-add]').forEach(function (btn) {
        var id = btn.getAttribute('data-combo-add');
        var label = btn.querySelector('.boun-cats__btn-label');
        if (combo.indexOf(id) !== -1) {
          btn.classList.add('is-added');
          if (label) label.textContent = '✓ En el combo';
        }
      });
    }

    /* v276 — ML-style quantity dropdown on related cards (replaces +/- stepper). */
    function bindQtyButtons(root) {
      function closeAll(except) {
        root.querySelectorAll('.boun-cats__qtybox.is-open').forEach(function (box) {
          if (box === except) return;
          box.classList.remove('is-open');
          var m = box.querySelector('[data-qty-menu]'); if (m) m.hidden = true;
          var t = box.querySelector('[data-qty-toggle]'); if (t) t.setAttribute('aria-expanded', 'false');
        });
      }
      root.addEventListener('click', function (e) {
        var toggle = e.target.closest('[data-qty-toggle]');
        var opt = e.target.closest('[data-qty-opt]');
        if (toggle) {
          var box = toggle.closest('[data-qtybox]');
          if (!box) return;
          var willOpen = !box.classList.contains('is-open');
          closeAll(box);
          var menu = box.querySelector('[data-qty-menu]');
          box.classList.toggle('is-open', willOpen);
          if (menu) menu.hidden = !willOpen;
          toggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
          return;
        }
        if (opt) {
          var box2 = opt.closest('[data-qtybox]');
          var form = opt.closest('[data-cart-form]');
          var v = parseInt(opt.getAttribute('data-qty-opt'), 10) || 1;
          if (form) { var hidden = form.querySelector('[data-qty-value]'); if (hidden) hidden.value = v; }
          if (box2) {
            var disp = box2.querySelector('[data-qty-display]'); if (disp) disp.textContent = v;
            box2.querySelectorAll('[data-qty-opt]').forEach(function (o) {
              var sel = o === opt;
              o.classList.toggle('is-selected', sel);
              o.setAttribute('aria-selected', sel ? 'true' : 'false');
            });
            closeAll(null);
          }
        }
      });
      if (!window.__bounRelQtyDocBound) {
        window.__bounRelQtyDocBound = true;
        var closeAllRel = function () {
          document.querySelectorAll('.boun-related .boun-cats__qtybox.is-open').forEach(function (box) {
            box.classList.remove('is-open');
            var m = box.querySelector('[data-qty-menu]'); if (m) m.hidden = true;
            var t = box.querySelector('[data-qty-toggle]'); if (t) t.setAttribute('aria-expanded', 'false');
          });
        };
        document.addEventListener('click', function (e) { if (!e.target.closest('[data-qtybox]')) closeAllRel(); });
        document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAllRel(); });
      }
    }

    function bindComboClicks(root) {
      root.addEventListener('click', function (e) {
        var comboBtn = e.target.closest('[data-combo-add]');
        if (!comboBtn) return;
        e.preventDefault();
        var id = comboBtn.getAttribute('data-combo-add');
        var line = comboBtn.getAttribute('data-line');
        comboBtn.classList.add('is-added');
        var lbl = comboBtn.querySelector('.boun-cats__btn-label');
        if (lbl) lbl.textContent = '✓ Yendo al combo…';
        try {
          var stage = JSON.parse(localStorage.getItem('boun-combo-stage') || '[]');
          if (stage.indexOf(id) === -1) stage.push(id);
          localStorage.setItem('boun-combo-stage', JSON.stringify(stage));
        } catch (err) {}
        window.location.href = '/pages/arma-tu-combo?from=' + encodeURIComponent(line || 'related');
      });
    }

    function bindCartForms(root) {
      root.addEventListener('submit', function (e) {
        var form = e.target.closest('[data-cart-form]');
        if (!form) return;
        e.preventDefault();
        var btn = form.querySelector('.boun-cats__btn--cart');
        var label = btn ? btn.querySelector('.boun-cats__btn-label') : null;
        var originalText = label ? label.textContent : 'Añadir al carrito';
        if (btn) {
          btn.classList.remove('is-added', 'is-error');
          btn.classList.add('is-loading');
          if (label) label.textContent = 'Añadiendo…';
        }
        var formData = new FormData(form);
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: formData
        })
          .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
          .then(function () {
            if (btn) {
              btn.classList.remove('is-loading');
              btn.classList.add('is-added');
              if (label) label.textContent = '✓ Añadido';
            }
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            setTimeout(function () {
              if (btn) btn.classList.remove('is-added');
              if (label) label.textContent = originalText;
            }, 2200);
          })
          .catch(function () {
            if (btn) {
              btn.classList.remove('is-loading');
              btn.classList.add('is-error');
              if (label) label.textContent = 'Error · Reintentar';
            }
            setTimeout(function () {
              if (btn) btn.classList.remove('is-error');
              if (label) label.textContent = originalText;
            }, 2400);
          });
      });
    }

    function initCarousel(root) {
      if (!root || root.__bounRelatedInit) return;
      root.__bounRelatedInit = true;

      var scroller = root.querySelector('[data-cats-scroller]');
      var dots     = root.querySelectorAll('[data-cats-dot]');
      var cells    = scroller ? scroller.querySelectorAll('.boun-cats__cell') : [];
      var prevBtn  = root.querySelector('[data-cats-prev]');
      var nextBtn  = root.querySelector('[data-cats-next]');
      var section  = root.querySelector('.boun-cats') || root;
      if (!scroller || !cells.length) return;

      function checkOverflow() {
        var hasOverflow = scroller.scrollWidth > scroller.clientWidth + 8;
        if (hasOverflow) section.classList.add('boun-cats--has-overflow');
        else section.classList.remove('boun-cats--has-overflow');
      }
      checkOverflow();
      window.addEventListener('resize', checkOverflow);

      function setActive(idx) {
        dots.forEach(function (d, i) {
          if (i === idx) { d.classList.add('is-active'); d.setAttribute('aria-selected', 'true'); }
          else { d.classList.remove('is-active'); d.setAttribute('aria-selected', 'false'); }
        });
      }

      function updateArrows() {
        if (!prevBtn || !nextBtn) return;
        var maxScroll = scroller.scrollWidth - scroller.clientWidth;
        var scrollLeft = scroller.scrollLeft;
        if (scrollLeft <= 4) prevBtn.setAttribute('hidden', '');
        else prevBtn.removeAttribute('hidden');
        if (scrollLeft >= maxScroll - 4) nextBtn.setAttribute('hidden', '');
        else nextBtn.removeAttribute('hidden');
      }
      updateArrows();
      scroller.addEventListener('scroll', updateArrows, { passive: true });
      window.addEventListener('resize', updateArrows);

      var io = new IntersectionObserver(function (entries) {
        var best = null;
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            if (!best || entry.intersectionRatio > best.intersectionRatio) best = entry;
          }
        });
        if (best) {
          var idx = Array.prototype.indexOf.call(cells, best.target);
          if (idx > -1) setActive(idx);
        }
      }, { root: scroller, threshold: [0.55, 0.75, 0.95] });
      cells.forEach(function (cell) { io.observe(cell); });

      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () {
          var target = cells[i];
          if (!target) return;
          var scrollerRect = scroller.getBoundingClientRect();
          var targetRect = target.getBoundingClientRect();
          var offset = (targetRect.left - scrollerRect.left) + (targetRect.width / 2) - (scrollerRect.width / 2);
          scroller.scrollBy({ left: offset, behavior: 'smooth' });
        });
      });

      function getStep() {
        if (!cells[0]) return 0;
        var rect = cells[0].getBoundingClientRect();
        return rect.width + 14;
      }
      if (nextBtn) nextBtn.addEventListener('click', function () {
        scroller.scrollBy({ left: getStep(), behavior: 'smooth' });
      });
      if (prevBtn) prevBtn.addEventListener('click', function () {
        scroller.scrollBy({ left: -getStep(), behavior: 'smooth' });
      });
    }

    /* v82 — Pill filter. Click a pill → show only matching cards.
       Toggle-off when clicking the active pill again (returns to "all"). */
    function initFilters(root) {
      if (!root || root.__bounRelatedFiltersInit) return;
      root.__bounRelatedFiltersInit = true;

      var pills = root.querySelectorAll('[data-cats-use]');
      var cells = root.querySelectorAll('.boun-cats__cell');
      var scroller = root.querySelector('[data-cats-scroller]');
      var emptyEl = root.querySelector('[data-cats-empty]');
      if (!pills.length || !cells.length) return;

      var activeUse = 'all';

      function applyFilter(use) {
        var visibleCount = 0;
        cells.forEach(function (cell) {
          var raw = cell.getAttribute('data-cats-uses') || '';
          var uses = raw.split(',').map(function (s) { return s.trim(); });
          var show = use === 'all' || uses.indexOf(use) !== -1;
          cell.classList.toggle('is-hidden', !show);
          if (show) visibleCount++;
        });
        // Toggle empty state when no matches
        root.classList.toggle('boun-cats--empty', visibleCount === 0);
        // Re-snap to first visible cell on filter change
        if (scroller) scroller.scrollLeft = 0;
      }

      pills.forEach(function (pill) {
        pill.addEventListener('click', function () {
          var use = pill.getAttribute('data-cats-use');
          var alreadyActive = pill.classList.contains('is-active');
          // Toggle-off: clicking the active pill (non-"all") reverts to "all"
          if (alreadyActive && use !== 'all') { use = 'all'; }
          activeUse = use;
          // Update pill UI
          pills.forEach(function (p) {
            var on = use === 'all' ? p.getAttribute('data-cats-use') === 'all' : p === pill;
            p.classList.toggle('is-active', on);
            p.setAttribute('aria-selected', on ? 'true' : 'false');
          });
          applyFilter(use);
        });
      });

      // Initial render
      applyFilter('all');
    }

    function init() {
      document.querySelectorAll('.boun-cats.boun-related').forEach(function (root) {
        syncComboButtons(root);
        bindQtyButtons(root);
        bindComboClicks(root);
        bindCartForms(root);
        initCarousel(root);
        initFilters(root);
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["boun-product-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* ===== 42 REAL reviews from MercadoLibre Colombia ===== */
    var REVIEWS = [
      /* Sleep — MCO46995498 — 13 reviews */
      { line: 'sleep', tag: 'Sleep · -24dB', color: '#8B7BD8', stars: 5, date: 'Hace 10 meses', imgs: [], text: 'Muy buenos, buena relación calidad-precio. Los uso casi todas las noches y desde entonces duermo mejor. Son cómodos aunque los primeros días me incomodaron mientras mi oreja se acostumbraba.' },
      { line: 'sleep', tag: 'Sleep · -24dB', color: '#8B7BD8', stars: 5, date: 'Hace 5 meses', imgs: ['https://http2.mlstatic.com/D_NQ_NP_2X_999402-MLA101819195694_122025-O.webp'], text: 'Funcionan a la perfección, mucho más económicos que los zenplugs.' },
      { line: 'sleep', tag: 'Sleep · -24dB', color: '#8B7BD8', stars: 5, date: 'Hace 5 meses', imgs: [], text: 'Yo los compré porque tenía problemas para dormir ya que vivo junto a una avenida, el ruido de los carros insoportable, no podía descansar. Y estos tapones para el precio están perfectos, no aíslan totalmente del ruido pero permiten descansar muy bien.' },
      { line: 'sleep', tag: 'Sleep · -24dB', color: '#8B7BD8', stars: 4, date: 'Hace 8 meses', imgs: [], text: 'Al utilizar el producto sí funciona para reducir el ruido exterior lo aclaro desde un principio pero hay que tener en cuenta que se sigue escuchando el ruido exterior de manera pasiva.' },
      { line: 'sleep', tag: 'Sleep · -24dB', color: '#8B7BD8', stars: 5, date: 'Hace 5 meses', imgs: [], text: 'Excelente producto, reduce hasta un 90% el ruido de los ronquidos de una persona a 1 metro.' },
      { line: 'sleep', tag: 'Sleep · -24dB', color: '#8B7BD8', stars: 5, date: 'Hace 10 meses', imgs: [], text: 'Excelente producto, gracias MercadoLibre.' },
      { line: 'sleep', tag: 'Sleep · -24dB', color: '#8B7BD8', stars: 5, date: 'Hace 2 meses', imgs: ['https://http2.mlstatic.com/D_NQ_NP_2X_941585-MLA108253312356_032026-O.webp'], text: 'Excelente producto. Muy cómodos para trabajar en lugar ruidoso y para dormir con ellos. Viene con diferentes tamaños y no se sienten.' },
      { line: 'sleep', tag: 'Sleep · -24dB', color: '#8B7BD8', stars: 5, date: 'Hace 3 meses', imgs: ['https://http2.mlstatic.com/D_NQ_NP_2X_875166-MLA105342183822_012026-O.webp'], text: 'Se ajustan bien al oído y aíslan bien de ronquidos y ruidos del exterior, perfectos para quienes duermen de día o necesitan concentrarse.' },
      { line: 'sleep', tag: 'Sleep · -24dB', color: '#8B7BD8', stars: 5, date: 'Hace 4 meses', imgs: ['https://http2.mlstatic.com/D_NQ_NP_2X_954817-MLA105500645709_012026-O.webp'], text: 'Son cómodos, al ser pequeños se acomodan perfectamente a mi oreja y al girar en la cama no son molestos.' },
      { line: 'sleep', tag: 'Sleep · -24dB', color: '#8B7BD8', stars: 5, date: 'Hace 4 meses', imgs: ['https://http2.mlstatic.com/D_NQ_NP_2X_989699-MLA104794398681_012026-O.webp'], text: 'Perfecto para los que tenemos sueño ligero. El apantallamiento es bueno sin ser excesivo. No son incómodos, incluso cuando se duerme encima de la oreja.' },
      { line: 'sleep', tag: 'Sleep · -24dB', color: '#8B7BD8', stars: 5, date: 'Hace 1 año', imgs: ['https://http2.mlstatic.com/D_NQ_NP_2X_868427-MLA84516963610_052025-O.webp'], text: 'Perfecto y económico, justo lo que se necesita.' },
      { line: 'sleep', tag: 'Sleep · -24dB', color: '#8B7BD8', stars: 5, date: 'Hace 3 semanas', imgs: ['https://http2.mlstatic.com/D_NQ_NP_2X_848211-MLA111095563507_042026-O.webp'], text: 'Excelente producto, viene en caja y adicionalmente con su estuche para llevarlo a cualquier parte. Cuenta con diferentes tamaños que permiten elegir el que más se adapte al conducto auditivo.' },
      { line: 'sleep', tag: 'Sleep · -24dB', color: '#8B7BD8', stars: 5, date: 'Hace 1 mes', imgs: ['https://http2.mlstatic.com/D_NQ_NP_2X_680270-MLA109909142780_042026-O.webp'], text: 'Cumplen muy bien su función de aislar el sonido.' },

      /* Swim — MCO46950572 — 14 reviews */
      { line: 'swim', tag: 'Swim · Impermeable', color: '#2DC6FF', stars: 5, date: 'Hace más de 1 año', imgs: [], text: 'Excelente.' },
      { line: 'swim', tag: 'Swim · Impermeable', color: '#2DC6FF', stars: 5, date: 'Hace 2 meses', imgs: ['https://http2.mlstatic.com/D_NQ_NP_2X_839722-MLA108376450042_032026-O.webp', 'https://http2.mlstatic.com/D_NQ_NP_2X_724813-MLA108376657952_032026-O.webp'], text: 'Fáciles de poner, no molestan para nada además me encanta que tenga su estuche y que en los protectores para los oídos en la parte de atrás indique en qué oído van (R/L).' },
      { line: 'swim', tag: 'Swim · Impermeable', color: '#2DC6FF', stars: 5, date: 'Hace 1 año', imgs: ['https://http2.mlstatic.com/D_NQ_NP_2X_704458-MLA81162294161_122024-O.webp', 'https://http2.mlstatic.com/D_NQ_NP_2X_694610-MLA81162284233_122024-O.webp'], text: 'Buen producto, buenos materiales, recomendado, calidad precio.' },
      { line: 'swim', tag: 'Swim · Impermeable', color: '#2DC6FF', stars: 5, date: 'Hace 3 meses', imgs: ['https://http2.mlstatic.com/D_NQ_NP_2X_787028-MLA106909342414_022026-O.webp'], text: 'Muy buen producto.' },
      { line: 'swim', tag: 'Swim · Impermeable', color: '#2DC6FF', stars: 5, date: 'Hace 3 meses', imgs: ['https://http2.mlstatic.com/D_NQ_NP_2X_729972-MLA106705911762_022026-O.webp'], text: 'Cumple con la función, muy cómodos.' },
      { line: 'swim', tag: 'Swim · Impermeable', color: '#2DC6FF', stars: 5, date: 'Hace 3 meses', imgs: ['https://http2.mlstatic.com/D_NQ_NP_2X_688170-MLA105720322588_012026-O.webp'], text: 'Excelentes.' },
      { line: 'swim', tag: 'Swim · Impermeable', color: '#2DC6FF', stars: 5, date: 'Hace 11 meses', imgs: ['https://http2.mlstatic.com/D_NQ_NP_2X_750183-MLA85012254694_052025-O.webp'], text: 'Excelente 👌 para principiantes en natación.' },
      { line: 'swim', tag: 'Swim · Impermeable', color: '#2DC6FF', stars: 5, date: 'Hace 1 año', imgs: ['https://http2.mlstatic.com/D_NQ_NP_2X_664214-MLA80584766326_112024-O.webp'], text: 'Muy chévere.' },
      { line: 'swim', tag: 'Swim · Impermeable', color: '#2DC6FF', stars: 4, date: 'Hace 1 semana', imgs: [], text: 'Se alcanza a filtrar un poco de agua incluso cuando se intentan empujar más al fondo del oído.' },
      { line: 'swim', tag: 'Swim · Impermeable', color: '#2DC6FF', stars: 5, date: 'Hace 1 mes', imgs: [], text: 'Bueno.' },
      { line: 'swim', tag: 'Swim · Impermeable', color: '#2DC6FF', stars: 5, date: 'Hace 2 meses', imgs: [], text: 'Lo que pedí exactamente.' },
      { line: 'swim', tag: 'Swim · Impermeable', color: '#2DC6FF', stars: 4, date: 'Hace 3 meses', imgs: [], text: 'Sencillos, buenos y útiles, cumplieron con su propósito. El clip de nariz es muy ajustado, parece más para ser usado por un niño, pero los tapa oídos funcionaron bien.' },
      { line: 'swim', tag: 'Swim · Impermeable', color: '#2DC6FF', stars: 5, date: 'Hace 4 meses', imgs: [], text: 'Muy buenos.' },
      { line: 'swim', tag: 'Swim · Impermeable', color: '#2DC6FF', stars: 4, date: 'Hace 4 meses', imgs: [], text: 'Buenos, aunque muy duros.' },

      /* Industrial — MCO46920975 — 15 reviews */
      { line: 'industrial', tag: 'Industrial · -40dB', color: '#FFD60A', stars: 4, date: 'Hace 4 meses', imgs: ['https://http2.mlstatic.com/D_NQ_NP_2X_860104-MLA104274375837_012026-O.webp'], text: 'Cómodos.' },
      { line: 'industrial', tag: 'Industrial · -40dB', color: '#FFD60A', stars: 5, date: 'Hace 4 meses', imgs: [], text: 'Me gustaron mucho.' },
      { line: 'industrial', tag: 'Industrial · -40dB', color: '#FFD60A', stars: 5, date: 'Hace 5 meses', imgs: [], text: 'Excelente, realmente al dormir no escucho nada, me ayuda a conciliar el sueño mucho más rápido. Recomendado.' },
      { line: 'industrial', tag: 'Industrial · -40dB', color: '#FFD60A', stars: 5, date: 'Hace 5 meses', imgs: [], text: 'Por fin pude dormir, hubo una papayera en el conjunto y ni cuenta me di. O sea, no hay mejor recomendación que la experiencia.' },
      { line: 'industrial', tag: 'Industrial · -40dB', color: '#FFD60A', stars: 5, date: 'Hace 6 meses', imgs: [], text: 'Excelente material. Suave al tacto de los oídos. No estorban al momento de apoyar la cabeza y aíslan muy bien el ruido. Recomendados.' },
      { line: 'industrial', tag: 'Industrial · -40dB', color: '#FFD60A', stars: 5, date: 'Hace 8 meses', imgs: [], text: 'Cumple su función, aunque no se ven de la mejor calidad.' },
      { line: 'industrial', tag: 'Industrial · -40dB', color: '#FFD60A', stars: 4, date: 'Hace 9 meses', imgs: [], text: 'Un poco incómodos.' },
      { line: 'industrial', tag: 'Industrial · -40dB', color: '#FFD60A', stars: 5, date: 'Hace 10 meses', imgs: [], text: 'El producto es muy útil, el material es cómodo y para mi sensibilidad auditiva son perfectos.' },
      { line: 'industrial', tag: 'Industrial · -40dB', color: '#FFD60A', stars: 5, date: 'Hace 11 meses', imgs: [], text: 'Son muy cómodos para dormir, realmente te aíslan el ruido.' },
      { line: 'industrial', tag: 'Industrial · -40dB', color: '#FFD60A', stars: 5, date: 'Hace 4 meses', imgs: ['https://http2.mlstatic.com/D_NQ_NP_2X_682921-MLA102835961948_012026-O.webp', 'https://http2.mlstatic.com/D_NQ_NP_2X_934349-MLA102836185056_012026-O.webp'], text: 'Buen producto.' },
      { line: 'industrial', tag: 'Industrial · -40dB', color: '#FFD60A', stars: 4, date: 'Hace 2 semanas', imgs: ['https://http2.mlstatic.com/D_NQ_NP_2X_803671-MLA111544293631_052026-O.webp', 'https://http2.mlstatic.com/D_NQ_NP_2X_606886-MLA111543619385_052026-O.webp'], text: 'Son un poco débiles y cuesta ponerlos en el oído pero una vez los logras acomodar bien, funciona perfecto.' },
      { line: 'industrial', tag: 'Industrial · -40dB', color: '#FFD60A', stars: 5, date: 'Hace 5 días', imgs: ['https://http2.mlstatic.com/D_NQ_NP_2X_689019-MLA111943327043_052026-O.webp'], text: 'Cumplen su función.' },
      { line: 'industrial', tag: 'Industrial · -40dB', color: '#FFD60A', stars: 5, date: 'Hace 1 semana', imgs: ['https://http2.mlstatic.com/D_NQ_NP_2X_711888-MLA111826560659_052026-O.webp'], text: 'Bueno, aunque no es lo mencionado en las especificaciones, no elimina 100% el ruido.' },
      { line: 'industrial', tag: 'Industrial · -40dB', color: '#FFD60A', stars: 5, date: 'Hace 1 semana', imgs: ['https://http2.mlstatic.com/D_NQ_NP_2X_697575-MLA110690385212_052026-O.webp'], text: 'Simplemente espectacular. La sensación de aislamiento es genial y son increíblemente cómodos. Totalmente recomendados.' }
    ];

    function shuffle(a) {
      var r = a.slice();
      for (var i = r.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var t = r[i]; r[i] = r[j]; r[j] = t;
      }
      return r;
    }

    function escapeHtml(s) {
      return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    }

    function renderStars(stars) {
      var html = '';
      var i;
      for (i = 0; i < 5; i++) {
        var filled = i < stars;
        html += '<svg viewBox="0 0 24 24" fill="' + (filled ? 'currentColor' : 'none') + '" stroke="' + (filled ? 'none' : 'currentColor') + '" stroke-width="' + (filled ? '0' : '1.5') + '" class="' + (filled ? '' : 'is-empty') + '" aria-hidden="true"><path d="m12 2 3 7h7l-5.5 4.5L18 21l-6-4.5L6 21l1.5-7.5L2 9h7z"/></svg>';
      }
      return html;
    }

    function renderPhotos(imgs) {
      if (!imgs || !imgs.length) return '';
      var html = '<div class="boun-reviews__photos">';
      imgs.forEach(function (url) {
        html += '<a href="' + escapeHtml(url) + '" target="_blank" rel="noopener" class="boun-reviews__photo">' +
                  '<img src="' + escapeHtml(url) + '" alt="Foto del cliente" loading="lazy" referrerpolicy="no-referrer">' +
                '</a>';
      });
      html += '</div>';
      return html;
    }

    function renderCard(r) {
      var card = document.createElement('article');
      card.className = 'boun-reviews__card';
      card.setAttribute('role', 'listitem');
      card.setAttribute('data-line', r.line);
      card.style.setProperty('--c', r.color);
      card.innerHTML =
        '<div class="boun-reviews__top">' +
          '<div class="boun-reviews__stars" aria-label="' + r.stars + ' estrellas">' + renderStars(r.stars) + '</div>' +
          '<span class="boun-reviews__tag">' + escapeHtml(r.tag) + '</span>' +
        '</div>' +
        renderPhotos(r.imgs) +
        '<p class="boun-reviews__text">' + escapeHtml(r.text) + '</p>' +
        '<footer class="boun-reviews__meta">' +
          '<span class="boun-reviews__name">Cliente verificado</span>' +
          '<span class="boun-reviews__sep">·</span>' +
          '<span class="boun-reviews__date">' + escapeHtml(r.date) + '</span>' +
          '<span class="boun-reviews__sep">·</span>' +
          '<span class="boun-reviews__src">Colombia</span>' +
        '</footer>';
      return card;
    }

    function init(root) {
      if (!root || root.__bounReviewsInit) return;
      root.__bounReviewsInit = true;
      var scroller = root.querySelector('[data-reviews-scroller]');
      if (!scroller) return;

      /* v49 — When data-line is set, filter REVIEWS to only that line.
         Used on /products/* pages so each product only shows its own
         reviews. If a line has no reviews (music, moto), the whole
         section hides instead of showing an empty carousel. */
      var line = root.dataset.line || '';
      var pool = REVIEWS;
      if (line) {
        pool = REVIEWS.filter(function (r) { return r.line === line; });
        if (!pool.length) {
          root.style.display = 'none';
          return;
        }
        /* Update the section lead with the actual review count */
        var lead = root.querySelector('[data-reviews-lead]');
        if (lead) {
          lead.textContent = pool.length + ' reseñas reales de clientes verificados en MercadoLibre Colombia.';
        }
      }

      /* Render reviews into the horizontal carousel, in a fresh random
         order each visit. With-photo reviews lead so the first couple
         of cards always show real customer pictures. */
      var withPhotos = pool.filter(function (r) { return r.imgs && r.imgs.length; });
      var withoutPhotos = pool.filter(function (r) { return !r.imgs || !r.imgs.length; });
      var ordered = shuffle(withPhotos).concat(shuffle(withoutPhotos));

      scroller.innerHTML = '';
      ordered.forEach(function (r, i) {
        var card = renderCard(r);
        card.style.animationDelay = (Math.min(i, 8) * 50) + 'ms';
        scroller.appendChild(card);
      });

      /* Navigation: arrows + progress bar */
      var prevBtn = root.querySelector('[data-reviews-prev]');
      var nextBtn = root.querySelector('[data-reviews-next]');
      var progressBar = root.querySelector('[data-reviews-progress]');

      function getStep() {
        var first = scroller.querySelector('.boun-reviews__card');
        if (!first) return 300;
        var rect = first.getBoundingClientRect();
        var gap = parseInt(getComputedStyle(scroller).gap, 10) || 18;
        return rect.width + gap;
      }
      function updateArrows() {
        if (!prevBtn || !nextBtn) return;
        var max = scroller.scrollWidth - scroller.clientWidth;
        var x = scroller.scrollLeft;
        if (x <= 4) prevBtn.setAttribute('hidden', '');
        else prevBtn.removeAttribute('hidden');
        if (x >= max - 4) nextBtn.setAttribute('hidden', '');
        else nextBtn.removeAttribute('hidden');
        if (progressBar && max > 0) {
          var pct = Math.min(1, Math.max(0, x / max));
          /* Bar is 20% wide; translate so right edge tracks scroll */
          var pos = (pct * 80);
          progressBar.style.transform = 'translateX(' + pos + '%)';
        }
      }
      if (nextBtn) nextBtn.addEventListener('click', function () { scroller.scrollBy({ left: getStep(), behavior: 'smooth' }); });
      if (prevBtn) prevBtn.addEventListener('click', function () { scroller.scrollBy({ left: -getStep(), behavior: 'smooth' }); });
      scroller.addEventListener('scroll', updateArrows, { passive: true });
      window.addEventListener('resize', updateArrows);
      /* Defer first update so layout settles */
      requestAnimationFrame(updateArrows);
      setTimeout(updateArrows, 150);

      /* v57 — Mobile dot indicators. Render one dot per card; observer
         updates active dot as user swipes. Mobile-only (hidden on desktop
         via CSS). Click a dot to scroll to that card. */
      var dotsContainer = root.querySelector('[data-reviews-dots]');
      if (dotsContainer) {
        var cards = scroller.querySelectorAll('.boun-reviews__card');
        dotsContainer.innerHTML = '';
        cards.forEach(function (card, i) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'boun-reviews__dot' + (i === 0 ? ' is-active' : '');
          dot.setAttribute('aria-label', 'Ver reseña ' + (i + 1));
          dot.setAttribute('role', 'tab');
          dot.addEventListener('click', function () {
            card.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
          });
          dotsContainer.appendChild(dot);
        });
        var dots = dotsContainer.querySelectorAll('.boun-reviews__dot');
        var dIo = new IntersectionObserver(function (entries) {
          var best = null;
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              if (!best || entry.intersectionRatio > best.intersectionRatio) best = entry;
            }
          });
          if (best) {
            var idx = Array.prototype.indexOf.call(cards, best.target);
            if (idx === -1) return;
            dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
          }
        }, { root: scroller, threshold: [0.5, 0.75, 0.95] });
        cards.forEach(function (c) { dIo.observe(c); });
      }

      /* Keyboard nav when scroller is focused */
      scroller.setAttribute('tabindex', '0');
      scroller.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); scroller.scrollBy({ left: getStep(), behavior: 'smooth' }); }
        else if (e.key === 'ArrowLeft')  { e.preventDefault(); scroller.scrollBy({ left: -getStep(), behavior: 'smooth' }); }
      });
    }

    function initAll() {
      document.querySelectorAll('[data-boun-reviews]').forEach(init);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["boun-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* ===== 42 REAL reviews from MercadoLibre Colombia ===== */
    var REVIEWS = [
      /* Sleep — MCO46995498 — 13 reviews */
      { line: 'sleep', tag: 'Sleep · -24dB', color: '#8B7BD8', stars: 5, date: 'Hace 10 meses', imgs: [], text: 'Muy buenos, buena relación calidad-precio. Los uso casi todas las noches y desde entonces duermo mejor. Son cómodos aunque los primeros días me incomodaron mientras mi oreja se acostumbraba.' },
      { line: 'sleep', tag: 'Sleep · -24dB', color: '#8B7BD8', stars: 5, date: 'Hace 5 meses', imgs: ['https://http2.mlstatic.com/D_NQ_NP_2X_999402-MLA101819195694_122025-O.webp'], text: 'Funcionan a la perfección, mucho más económicos que los zenplugs.' },
      { line: 'sleep', tag: 'Sleep · -24dB', color: '#8B7BD8', stars: 5, date: 'Hace 5 meses', imgs: [], text: 'Yo los compré porque tenía problemas para dormir ya que vivo junto a una avenida, el ruido de los carros insoportable, no podía descansar. Y estos tapones para el precio están perfectos, no aíslan totalmente del ruido pero permiten descansar muy bien.' },
      { line: 'sleep', tag: 'Sleep · -24dB', color: '#8B7BD8', stars: 4, date: 'Hace 8 meses', imgs: [], text: 'Al utilizar el producto sí funciona para reducir el ruido exterior lo aclaro desde un principio pero hay que tener en cuenta que se sigue escuchando el ruido exterior de manera pasiva.' },
      { line: 'sleep', tag: 'Sleep · -24dB', color: '#8B7BD8', stars: 5, date: 'Hace 5 meses', imgs: [], text: 'Excelente producto, reduce hasta un 90% el ruido de los ronquidos de una persona a 1 metro.' },
      { line: 'sleep', tag: 'Sleep · -24dB', color: '#8B7BD8', stars: 5, date: 'Hace 10 meses', imgs: [], text: 'Excelente producto, gracias MercadoLibre.' },
      { line: 'sleep', tag: 'Sleep · -24dB', color: '#8B7BD8', stars: 5, date: 'Hace 2 meses', imgs: ['https://http2.mlstatic.com/D_NQ_NP_2X_941585-MLA108253312356_032026-O.webp'], text: 'Excelente producto. Muy cómodos para trabajar en lugar ruidoso y para dormir con ellos. Viene con diferentes tamaños y no se sienten.' },
      { line: 'sleep', tag: 'Sleep · -24dB', color: '#8B7BD8', stars: 5, date: 'Hace 3 meses', imgs: ['https://http2.mlstatic.com/D_NQ_NP_2X_875166-MLA105342183822_012026-O.webp'], text: 'Se ajustan bien al oído y aíslan bien de ronquidos y ruidos del exterior, perfectos para quienes duermen de día o necesitan concentrarse.' },
      { line: 'sleep', tag: 'Sleep · -24dB', color: '#8B7BD8', stars: 5, date: 'Hace 4 meses', imgs: ['https://http2.mlstatic.com/D_NQ_NP_2X_954817-MLA105500645709_012026-O.webp'], text: 'Son cómodos, al ser pequeños se acomodan perfectamente a mi oreja y al girar en la cama no son molestos.' },
      { line: 'sleep', tag: 'Sleep · -24dB', color: '#8B7BD8', stars: 5, date: 'Hace 4 meses', imgs: ['https://http2.mlstatic.com/D_NQ_NP_2X_989699-MLA104794398681_012026-O.webp'], text: 'Perfecto para los que tenemos sueño ligero. El apantallamiento es bueno sin ser excesivo. No son incómodos, incluso cuando se duerme encima de la oreja.' },
      { line: 'sleep', tag: 'Sleep · -24dB', color: '#8B7BD8', stars: 5, date: 'Hace 1 año', imgs: ['https://http2.mlstatic.com/D_NQ_NP_2X_868427-MLA84516963610_052025-O.webp'], text: 'Perfecto y económico, justo lo que se necesita.' },
      { line: 'sleep', tag: 'Sleep · -24dB', color: '#8B7BD8', stars: 5, date: 'Hace 3 semanas', imgs: ['https://http2.mlstatic.com/D_NQ_NP_2X_848211-MLA111095563507_042026-O.webp'], text: 'Excelente producto, viene en caja y adicionalmente con su estuche para llevarlo a cualquier parte. Cuenta con diferentes tamaños que permiten elegir el que más se adapte al conducto auditivo.' },
      { line: 'sleep', tag: 'Sleep · -24dB', color: '#8B7BD8', stars: 5, date: 'Hace 1 mes', imgs: ['https://http2.mlstatic.com/D_NQ_NP_2X_680270-MLA109909142780_042026-O.webp'], text: 'Cumplen muy bien su función de aislar el sonido.' },

      /* Swim — MCO46950572 — 14 reviews */
      { line: 'swim', tag: 'Swim · Impermeable', color: '#2DC6FF', stars: 5, date: 'Hace más de 1 año', imgs: [], text: 'Excelente.' },
      { line: 'swim', tag: 'Swim · Impermeable', color: '#2DC6FF', stars: 5, date: 'Hace 2 meses', imgs: ['https://http2.mlstatic.com/D_NQ_NP_2X_839722-MLA108376450042_032026-O.webp', 'https://http2.mlstatic.com/D_NQ_NP_2X_724813-MLA108376657952_032026-O.webp'], text: 'Fáciles de poner, no molestan para nada además me encanta que tenga su estuche y que en los protectores para los oídos en la parte de atrás indique en qué oído van (R/L).' },
      { line: 'swim', tag: 'Swim · Impermeable', color: '#2DC6FF', stars: 5, date: 'Hace 1 año', imgs: ['https://http2.mlstatic.com/D_NQ_NP_2X_704458-MLA81162294161_122024-O.webp', 'https://http2.mlstatic.com/D_NQ_NP_2X_694610-MLA81162284233_122024-O.webp'], text: 'Buen producto, buenos materiales, recomendado, calidad precio.' },
      { line: 'swim', tag: 'Swim · Impermeable', color: '#2DC6FF', stars: 5, date: 'Hace 3 meses', imgs: ['https://http2.mlstatic.com/D_NQ_NP_2X_787028-MLA106909342414_022026-O.webp'], text: 'Muy buen producto.' },
      { line: 'swim', tag: 'Swim · Impermeable', color: '#2DC6FF', stars: 5, date: 'Hace 3 meses', imgs: ['https://http2.mlstatic.com/D_NQ_NP_2X_729972-MLA106705911762_022026-O.webp'], text: 'Cumple con la función, muy cómodos.' },
      { line: 'swim', tag: 'Swim · Impermeable', color: '#2DC6FF', stars: 5, date: 'Hace 3 meses', imgs: ['https://http2.mlstatic.com/D_NQ_NP_2X_688170-MLA105720322588_012026-O.webp'], text: 'Excelentes.' },
      { line: 'swim', tag: 'Swim · Impermeable', color: '#2DC6FF', stars: 5, date: 'Hace 11 meses', imgs: ['https://http2.mlstatic.com/D_NQ_NP_2X_750183-MLA85012254694_052025-O.webp'], text: 'Excelente 👌 para principiantes en natación.' },
      { line: 'swim', tag: 'Swim · Impermeable', color: '#2DC6FF', stars: 5, date: 'Hace 1 año', imgs: ['https://http2.mlstatic.com/D_NQ_NP_2X_664214-MLA80584766326_112024-O.webp'], text: 'Muy chévere.' },
      { line: 'swim', tag: 'Swim · Impermeable', color: '#2DC6FF', stars: 4, date: 'Hace 1 semana', imgs: [], text: 'Se alcanza a filtrar un poco de agua incluso cuando se intentan empujar más al fondo del oído.' },
      { line: 'swim', tag: 'Swim · Impermeable', color: '#2DC6FF', stars: 5, date: 'Hace 1 mes', imgs: [], text: 'Bueno.' },
      { line: 'swim', tag: 'Swim · Impermeable', color: '#2DC6FF', stars: 5, date: 'Hace 2 meses', imgs: [], text: 'Lo que pedí exactamente.' },
      { line: 'swim', tag: 'Swim · Impermeable', color: '#2DC6FF', stars: 4, date: 'Hace 3 meses', imgs: [], text: 'Sencillos, buenos y útiles, cumplieron con su propósito. El clip de nariz es muy ajustado, parece más para ser usado por un niño, pero los tapa oídos funcionaron bien.' },
      { line: 'swim', tag: 'Swim · Impermeable', color: '#2DC6FF', stars: 5, date: 'Hace 4 meses', imgs: [], text: 'Muy buenos.' },
      { line: 'swim', tag: 'Swim · Impermeable', color: '#2DC6FF', stars: 4, date: 'Hace 4 meses', imgs: [], text: 'Buenos, aunque muy duros.' },

      /* Industrial — MCO46920975 — 15 reviews */
      { line: 'industrial', tag: 'Industrial · -40dB', color: '#FFD60A', stars: 4, date: 'Hace 4 meses', imgs: ['https://http2.mlstatic.com/D_NQ_NP_2X_860104-MLA104274375837_012026-O.webp'], text: 'Cómodos.' },
      { line: 'industrial', tag: 'Industrial · -40dB', color: '#FFD60A', stars: 5, date: 'Hace 4 meses', imgs: [], text: 'Me gustaron mucho.' },
      { line: 'industrial', tag: 'Industrial · -40dB', color: '#FFD60A', stars: 5, date: 'Hace 5 meses', imgs: [], text: 'Excelente, realmente al dormir no escucho nada, me ayuda a conciliar el sueño mucho más rápido. Recomendado.' },
      { line: 'industrial', tag: 'Industrial · -40dB', color: '#FFD60A', stars: 5, date: 'Hace 5 meses', imgs: [], text: 'Por fin pude dormir, hubo una papayera en el conjunto y ni cuenta me di. O sea, no hay mejor recomendación que la experiencia.' },
      { line: 'industrial', tag: 'Industrial · -40dB', color: '#FFD60A', stars: 5, date: 'Hace 6 meses', imgs: [], text: 'Excelente material. Suave al tacto de los oídos. No estorban al momento de apoyar la cabeza y aíslan muy bien el ruido. Recomendados.' },
      { line: 'industrial', tag: 'Industrial · -40dB', color: '#FFD60A', stars: 5, date: 'Hace 8 meses', imgs: [], text: 'Cumple su función, aunque no se ven de la mejor calidad.' },
      { line: 'industrial', tag: 'Industrial · -40dB', color: '#FFD60A', stars: 4, date: 'Hace 9 meses', imgs: [], text: 'Un poco incómodos.' },
      { line: 'industrial', tag: 'Industrial · -40dB', color: '#FFD60A', stars: 5, date: 'Hace 10 meses', imgs: [], text: 'El producto es muy útil, el material es cómodo y para mi sensibilidad auditiva son perfectos.' },
      { line: 'industrial', tag: 'Industrial · -40dB', color: '#FFD60A', stars: 5, date: 'Hace 11 meses', imgs: [], text: 'Son muy cómodos para dormir, realmente te aíslan el ruido.' },
      { line: 'industrial', tag: 'Industrial · -40dB', color: '#FFD60A', stars: 5, date: 'Hace 4 meses', imgs: ['https://http2.mlstatic.com/D_NQ_NP_2X_682921-MLA102835961948_012026-O.webp', 'https://http2.mlstatic.com/D_NQ_NP_2X_934349-MLA102836185056_012026-O.webp'], text: 'Buen producto.' },
      { line: 'industrial', tag: 'Industrial · -40dB', color: '#FFD60A', stars: 4, date: 'Hace 2 semanas', imgs: ['https://http2.mlstatic.com/D_NQ_NP_2X_803671-MLA111544293631_052026-O.webp', 'https://http2.mlstatic.com/D_NQ_NP_2X_606886-MLA111543619385_052026-O.webp'], text: 'Son un poco débiles y cuesta ponerlos en el oído pero una vez los logras acomodar bien, funciona perfecto.' },
      { line: 'industrial', tag: 'Industrial · -40dB', color: '#FFD60A', stars: 5, date: 'Hace 5 días', imgs: ['https://http2.mlstatic.com/D_NQ_NP_2X_689019-MLA111943327043_052026-O.webp'], text: 'Cumplen su función.' },
      { line: 'industrial', tag: 'Industrial · -40dB', color: '#FFD60A', stars: 5, date: 'Hace 1 semana', imgs: ['https://http2.mlstatic.com/D_NQ_NP_2X_711888-MLA111826560659_052026-O.webp'], text: 'Bueno, aunque no es lo mencionado en las especificaciones, no elimina 100% el ruido.' },
      { line: 'industrial', tag: 'Industrial · -40dB', color: '#FFD60A', stars: 5, date: 'Hace 1 semana', imgs: ['https://http2.mlstatic.com/D_NQ_NP_2X_697575-MLA110690385212_052026-O.webp'], text: 'Simplemente espectacular. La sensación de aislamiento es genial y son increíblemente cómodos. Totalmente recomendados.' }
    ];

    function shuffle(a) {
      var r = a.slice();
      for (var i = r.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var t = r[i]; r[i] = r[j]; r[j] = t;
      }
      return r;
    }

    function escapeHtml(s) {
      return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    }

    function renderStars(stars) {
      var html = '';
      var i;
      for (i = 0; i < 5; i++) {
        var filled = i < stars;
        html += '<svg viewBox="0 0 24 24" fill="' + (filled ? 'currentColor' : 'none') + '" stroke="' + (filled ? 'none' : 'currentColor') + '" stroke-width="' + (filled ? '0' : '1.5') + '" class="' + (filled ? '' : 'is-empty') + '" aria-hidden="true"><path d="m12 2 3 7h7l-5.5 4.5L18 21l-6-4.5L6 21l1.5-7.5L2 9h7z"/></svg>';
      }
      return html;
    }

    function renderPhotos(imgs) {
      if (!imgs || !imgs.length) return '';
      var html = '<div class="boun-reviews__photos">';
      imgs.forEach(function (url) {
        html += '<a href="' + escapeHtml(url) + '" target="_blank" rel="noopener" class="boun-reviews__photo">' +
                  '<img src="' + escapeHtml(url) + '" alt="Foto del cliente" loading="lazy" referrerpolicy="no-referrer">' +
                '</a>';
      });
      html += '</div>';
      return html;
    }

    function renderCard(r) {
      var card = document.createElement('article');
      card.className = 'boun-reviews__card';
      card.setAttribute('role', 'listitem');
      card.setAttribute('data-line', r.line);
      card.style.setProperty('--c', r.color);
      card.innerHTML =
        '<div class="boun-reviews__top">' +
          '<div class="boun-reviews__stars" aria-label="' + r.stars + ' estrellas">' + renderStars(r.stars) + '</div>' +
          '<span class="boun-reviews__tag">' + escapeHtml(r.tag) + '</span>' +
        '</div>' +
        renderPhotos(r.imgs) +
        '<p class="boun-reviews__text">' + escapeHtml(r.text) + '</p>' +
        '<footer class="boun-reviews__meta">' +
          '<span class="boun-reviews__name">Cliente verificado</span>' +
          '<span class="boun-reviews__sep">·</span>' +
          '<span class="boun-reviews__date">' + escapeHtml(r.date) + '</span>' +
          '<span class="boun-reviews__sep">·</span>' +
          '<span class="boun-reviews__src">Colombia</span>' +
        '</footer>';
      return card;
    }

    function init(root) {
      if (!root || root.__bounReviewsInit) return;
      root.__bounReviewsInit = true;
      var scroller = root.querySelector('[data-reviews-scroller]');
      if (!scroller) return;

      /* Render ALL reviews into the horizontal carousel, but in a fresh
         random order each visit. With-photo reviews lead so the first
         couple of cards always show real customer pictures. */
      var withPhotos = REVIEWS.filter(function (r) { return r.imgs && r.imgs.length; });
      var withoutPhotos = REVIEWS.filter(function (r) { return !r.imgs || !r.imgs.length; });
      var ordered = shuffle(withPhotos).concat(shuffle(withoutPhotos));

      scroller.innerHTML = '';
      ordered.forEach(function (r, i) {
        var card = renderCard(r);
        card.style.animationDelay = (Math.min(i, 8) * 50) + 'ms';
        scroller.appendChild(card);
      });

      /* Navigation: arrows + progress bar */
      var prevBtn = root.querySelector('[data-reviews-prev]');
      var nextBtn = root.querySelector('[data-reviews-next]');
      var progressBar = root.querySelector('[data-reviews-progress]');

      function getStep() {
        var first = scroller.querySelector('.boun-reviews__card');
        if (!first) return 300;
        var rect = first.getBoundingClientRect();
        var gap = parseInt(getComputedStyle(scroller).gap, 10) || 18;
        return rect.width + gap;
      }
      function updateArrows() {
        if (!prevBtn || !nextBtn) return;
        var max = scroller.scrollWidth - scroller.clientWidth;
        var x = scroller.scrollLeft;
        if (x <= 4) prevBtn.setAttribute('hidden', '');
        else prevBtn.removeAttribute('hidden');
        if (x >= max - 4) nextBtn.setAttribute('hidden', '');
        else nextBtn.removeAttribute('hidden');
        if (progressBar && max > 0) {
          var pct = Math.min(1, Math.max(0, x / max));
          /* Bar is 20% wide; translate so right edge tracks scroll */
          var pos = (pct * 80);
          progressBar.style.transform = 'translateX(' + pos + '%)';
        }
      }
      if (nextBtn) nextBtn.addEventListener('click', function () { scroller.scrollBy({ left: getStep(), behavior: 'smooth' }); });
      if (prevBtn) prevBtn.addEventListener('click', function () { scroller.scrollBy({ left: -getStep(), behavior: 'smooth' }); });
      scroller.addEventListener('scroll', updateArrows, { passive: true });
      window.addEventListener('resize', updateArrows);
      /* Defer first update so layout settles */
      requestAnimationFrame(updateArrows);
      setTimeout(updateArrows, 150);

      /* Keyboard nav when scroller is focused */
      scroller.setAttribute('tabindex', '0');
      scroller.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); scroller.scrollBy({ left: getStep(), behavior: 'smooth' }); }
        else if (e.key === 'ArrowLeft')  { e.preventDefault(); scroller.scrollBy({ left: -getStep(), behavior: 'smooth' }); }
      });
    }

    function initAll() {
      document.querySelectorAll('[data-boun-reviews]').forEach(init);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["boun-shop"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';
    var STORAGE_KEY = 'boun-combo';

    function getCombo() {
      try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); }
      catch (e) { return []; }
    }
    function syncComboButtons(root) {
      var combo = getCombo();
      root.querySelectorAll('[data-combo-add]').forEach(function (btn) {
        var id = btn.getAttribute('data-combo-add');
        var label = btn.querySelector('.boun-shop__btn-label');
        if (combo.indexOf(id) !== -1) {
          btn.classList.add('is-added');
          if (label) label.textContent = '✓ En el combo';
        } else {
          btn.classList.remove('is-added');
          if (label) label.textContent = 'Añadir al combo';
        }
      });
    }

    function initShop(root) {
      if (!root || root.__bounShopInit) return;
      root.__bounShopInit = true;

      var grid     = root.querySelector('[data-shop-grid]');
      var tabs     = root.querySelectorAll('[data-shop-cat]');
      var pills    = root.querySelectorAll('[data-shop-use]');
      var cards    = root.querySelectorAll('.boun-shop__card');
      var counter  = root.querySelector('[data-shop-visible]');
      var resetBtn = root.querySelector('[data-shop-reset]');
      var emptyEl  = root.querySelector('[data-shop-empty]');
      var clearBtn = root.querySelector('[data-shop-clear]');
      if (!grid || !cards.length) return;

      var state = { cat: 'all', use: 'all' };

      function applyFilter() {
        var visibleCount = 0;
        cards.forEach(function (card) {
          var cardCat  = card.getAttribute('data-shop-cat') || '';
          var cardUses = (card.getAttribute('data-shop-uses') || '').split(',').map(function (s) { return s.trim(); });
          var matchCat = state.cat === 'all' || cardCat === state.cat;
          var matchUse = state.use === 'all' || cardUses.indexOf(state.use) !== -1;
          var show = matchCat && matchUse;
          card.classList.toggle('is-hidden', !show);
          if (show) visibleCount++;
        });
        if (counter) counter.textContent = visibleCount;
        if (resetBtn) {
          if (state.cat !== 'all' || state.use !== 'all') resetBtn.removeAttribute('hidden');
          else resetBtn.setAttribute('hidden', '');
        }
        if (emptyEl) {
          if (visibleCount === 0) emptyEl.removeAttribute('hidden');
          else emptyEl.setAttribute('hidden', '');
        }
        /* v66 — toggle .has-filter on the grid so the bundle CTA card
           hides when any filter is active (keeps grid focused). */
        if (grid) {
          var isFiltered = state.cat !== 'all' || state.use !== 'all';
          grid.classList.toggle('has-filter', isFiltered);
        }
        // emit event so other sections can react if needed
        root.dispatchEvent(new CustomEvent('boun:shop:filter', {
          detail: { cat: state.cat, use: state.use, visible: visibleCount }
        }));
      }

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          if (tab.hasAttribute('disabled') || tab.classList.contains('is-disabled')) return;
          var cat = tab.getAttribute('data-shop-cat');
          state.cat = cat;
          tabs.forEach(function (t) {
            var on = t === tab;
            t.classList.toggle('is-active', on);
            t.setAttribute('aria-selected', on ? 'true' : 'false');
          });
          applyFilter();
        });
      });

      /* v63 — Mobile collapsible pills toggle */
      var pillsWrap = root.querySelector('[data-shop-pills-wrap]');
      var pillsToggle = root.querySelector('[data-shop-pills-toggle]');
      var pillsLabel = root.querySelector('[data-shop-pills-label]');
      function setPillsLabel(pill) {
        if (!pillsLabel || !pill) return;
        var span = pill.querySelector('span');
        if (span) pillsLabel.textContent = 'Filtrar: ' + span.textContent;
      }
      if (pillsToggle && pillsWrap) {
        pillsToggle.addEventListener('click', function () {
          var isOpen = pillsWrap.classList.toggle('is-open');
          pillsToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        });
      }

      pills.forEach(function (pill) {
        pill.addEventListener('click', function () {
          var use = pill.getAttribute('data-shop-use');
          /* v65 — toggle-off when clicking an already-active pill */
          var alreadyActive = pill.classList.contains('is-active');
          if (alreadyActive && use !== 'all') { use = 'all'; }
          state.use = use;
          pills.forEach(function (p) {
            var on = use === 'all' ? p.getAttribute('data-shop-use') === 'all' : p === pill;
            p.classList.toggle('is-active', on);
            p.setAttribute('aria-selected', on ? 'true' : 'false');
          });
          applyFilter();
          /* Auto-collapse pills on mobile + update toggle label */
          if (pillsWrap) pillsWrap.classList.remove('is-open');
          if (pillsToggle) pillsToggle.setAttribute('aria-expanded', 'false');
          setPillsLabel(pill);
        });
      });
      /* Initialize toggle label from currently active pill */
      var activePill = root.querySelector('[data-shop-use].is-active') || pills[0];
      setPillsLabel(activePill);

      function reset() {
        state.cat = 'all'; state.use = 'all';
        tabs.forEach(function (t) {
          var on = t.getAttribute('data-shop-cat') === 'all';
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        pills.forEach(function (p) {
          var on = p.getAttribute('data-shop-use') === 'all';
          p.classList.toggle('is-active', on);
          p.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        applyFilter();
      }
      if (resetBtn) resetBtn.addEventListener('click', reset);
      if (clearBtn) clearBtn.addEventListener('click', reset);

      syncComboButtons(root);
      applyFilter();
    }

    /* v270 — ML-style quantity dropdown on shop cards (delegated). Writes the
       chosen value into the hidden [data-qty-value] input for add-to-cart. */
    function bounShopCloseQty(except) {
      document.querySelectorAll('[data-boun-shop] .boun-shop__qtybox.is-open').forEach(function (box) {
        if (box === except) return;
        box.classList.remove('is-open');
        var m = box.querySelector('[data-qty-menu]'); if (m) m.hidden = true;
        var t = box.querySelector('[data-qty-toggle]'); if (t) t.setAttribute('aria-expanded', 'false');
      });
    }
    document.addEventListener('click', function (e) {
      var toggle = e.target.closest('[data-boun-shop] [data-qty-toggle]');
      var opt = e.target.closest('[data-boun-shop] [data-qty-opt]');
      if (!toggle && !opt) { bounShopCloseQty(null); return; }
      if (toggle) {
        var box = toggle.closest('[data-qtybox]');
        if (!box) return;
        var willOpen = !box.classList.contains('is-open');
        bounShopCloseQty(box);
        var menu = box.querySelector('[data-qty-menu]');
        box.classList.toggle('is-open', willOpen);
        if (menu) menu.hidden = !willOpen;
        toggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        return;
      }
      if (opt) {
        var box2 = opt.closest('[data-qtybox]');
        var form = opt.closest('[data-cart-form]');
        var v = parseInt(opt.getAttribute('data-qty-opt'), 10) || 1;
        if (form) { var hidden = form.querySelector('[data-qty-value]'); if (hidden) hidden.value = v; }
        if (box2) {
          var disp = box2.querySelector('[data-qty-display]'); if (disp) disp.textContent = v;
          box2.querySelectorAll('[data-qty-opt]').forEach(function (o) {
            var sel = o === opt;
            o.classList.toggle('is-selected', sel);
            o.setAttribute('aria-selected', sel ? 'true' : 'false');
          });
          bounShopCloseQty(null);
        }
      }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') bounShopCloseQty(null); });

    // Cart add (delegated, same pattern as cats section)
    document.addEventListener('click', function (e) {
      var comboBtn = e.target.closest('[data-boun-shop] [data-combo-add]');
      if (!comboBtn) return;
      e.preventDefault();
      var id = comboBtn.getAttribute('data-combo-add');
      var line = comboBtn.getAttribute('data-line');
      comboBtn.classList.add('is-added');
      var lbl = comboBtn.querySelector('.boun-shop__btn-label');
      if (lbl) lbl.textContent = '✓ Yendo al combo…';
      try {
        var stage = JSON.parse(localStorage.getItem('boun-combo-stage') || '[]');
        if (stage.indexOf(id) === -1) stage.push(id);
        localStorage.setItem('boun-combo-stage', JSON.stringify(stage));
      } catch (err) {}
      window.location.href = '/pages/arma-tu-combo?from=' + encodeURIComponent(line || 'shop');
    });

    document.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-boun-shop] [data-cart-form]');
      if (!form) return;
      e.preventDefault();
      var btn = form.querySelector('.boun-shop__btn--cart');
      var label = btn ? btn.querySelector('.boun-shop__btn-label') : null;
      var originalText = label ? label.textContent : 'Añadir al carrito';
      if (btn) {
        btn.classList.remove('is-added', 'is-error');
        btn.classList.add('is-loading');
        if (label) label.textContent = 'Añadiendo…';
      }
      var formData = new FormData(form);
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
        .then(function () {
          if (btn) {
            btn.classList.remove('is-loading');
            btn.classList.add('is-added');
            if (label) label.textContent = '✓ Añadido';
          }
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          document.dispatchEvent(new CustomEvent('boun:cart:added', { detail: { line: form.dataset.line } }));
          /* v95.1 — Open cart drawer in place (matches product page + combo flow) */
          if (typeof window.openBounCartDrawer === 'function') {
            window.openBounCartDrawer();
          }
          setTimeout(function () {
            if (btn) btn.classList.remove('is-added');
            if (label) label.textContent = originalText;
          }, 2200);
        })
        .catch(function () {
          if (btn) {
            btn.classList.remove('is-loading');
            btn.classList.add('is-error');
            if (label) label.textContent = 'Error · Reintentar';
          }
          setTimeout(function () {
            if (btn) btn.classList.remove('is-error');
            if (label) label.textContent = originalText;
          }, 2400);
        });
    });

    function initAll() {
      document.querySelectorAll('[data-boun-shop]').forEach(initShop);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
